<template>
  <div v-if="$can('read','jobs')">
    <template v-if="jobHeaderLoading && !jobData">
      <b-card class="mt-50">
        <div class="text-center py-3">
          <b-spinner variant="primary" label="Loading job details" />
          <p class="mb-0 mt-1 text-muted">Loading job details…</p>
        </div>
      </b-card>
      <b-card class="mt-1">
        <h2 class="mb-1">Candidates Pool</h2>
        <div class="text-center py-3">
          <b-spinner small variant="primary" label="Loading candidates" />
          <p class="mb-0 mt-1 text-muted">Loading candidates…</p>
        </div>
      </b-card>
    </template>
    <template v-else-if="jobLoadError && !jobData">
      <b-card class="mt-50">
        <div class="text-center py-3">
          <h4 class="mb-1">{{ jobLoadErrorTitle }}</h4>
          <p class="mb-0 text-muted">{{ jobLoadErrorMessage }}</p>
        </div>
      </b-card>
    </template>
    <template v-else-if="jobData">
      <b-row>
        <b-col cols="12" xl="12">
          <!--<jobs-view-job-info-card :job-data="jobData" :notes="notes" :file="jobData.attachments" :job-description="jobData.job_description"/>-->
          <div>
            <b-tabs v-model="activeTabIndex" content-class="mt-1">
              <b-tab title="Job Details" id="job-details">
                <b-card no-body class="card-browser-states mt-50">
                  <b-card-header>
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="mb-0 ml-1">
                        {{ jobData.job_id }} - {{ jobData.position_name }}
                        <span class="card-text" v-if="jobData.role"
                          >| {{ jobData.role }}</span
                        >
                        <span class="card-text" v-if="jobData.band && jobData.band !== 'undefined'"
                          >| {{ jobData.band }}</span
                        >
                      </h4>
                      <div v-if="$can('manage','job_status') && jobData.status === 'Approval Pending'">
                        <b-button 
                          variant="success" 
                          size="sm"
                          @click="openApprovalModal"
                        >
                          <feather-icon icon="CheckCircleIcon" size="16" class="mr-1" />
                          Approve Job
                        </b-button>
                      </div>
                      
                    </div>
                    
                    <b-col md="6" xl="6" xs="6" v-if="jobData.status !== 'Approval Pending'">
                      <div>
                        <div class="demo-inline-spacing">
                          <b-avatar
                            v-b-tooltip.hover
                            :text="avatarCountText(jobData.initiated)"
                            variant="light-secondary"
                            badge="I"
                            title="Initiated"
                          />
                          <b-avatar
                            v-b-tooltip.hover
                            :text="avatarCountText(jobData.profileshared)"
                            variant="light-info"
                            badge="P"
                            title="Profile-Shared"
                          />
                          <b-avatar
                            v-b-tooltip.hover
                            :text="avatarCountText(jobData.inprocess)"
                            variant="light-success"
                            badge="I"
                            title="Inprocess"
                          />
                          <b-avatar
                            v-b-tooltip.hover
                            :text="avatarCountText(jobData.shortlisted)"
                            variant="light-primary"
                            badge="S"
                            title="Shortlisted"
                          />

                          <b-avatar
                            v-b-tooltip.hover
                            :text="avatarCountText(jobData.offered)"
                            variant="light-primary"
                            badge="O"
                            title="Offered"
                          />
                          <b-avatar
                            v-b-tooltip.hover
                            :text="avatarCountText(jobData.joined)"
                            variant="light-primary"
                            badge="J"
                            title="Joined"
                          />
                        </div>
                      </div>
                    </b-col>
                  </b-card-header>

                  <!-- body -->
                  <b-card-body style="padding: 1rem !important">
                    <b-row style="color: #5e5873 !important; font-size: 0.9rem">
                      <b-col md="3" xl="3" xs="6" sm="6">
                        <div class="mb-1">
                          <h4 class="mb-0">
                            <span>{{ jobData.client }}</span>
                            |
                            <span>{{ jobData.domain }}</span>
                          </h4>
                          <span class="card-text" :class="{'text-danger': jobData.status === 'Approval Pending'}">{{ jobData.status }}</span> |
                          <!-- <span class="card-text">{{ jobData.type }}</span> | -->
                          <span class="card-text">
                            Added on {{ formatJobDate(jobData.createdAt) }}</span
                          >
                          <br>
                          <span class="card-text">{{ jobData.type }}</span> | 
                          <span class="card-text">{{ jobData.category }}</span> | 
                          <span class="card-text">{{ jobData.payroll }}</span> |
                          <span class="card-text">{{ jobData.vertical }}</span>
                          <!--<span class="card-text"> {{ job.id }}</span>-->
                          <p>
                            <span class="card-text">{{
                              jobData.locations
                            }}</span>
                          </p>
                        </div>
                      </b-col>
                      <b-col md="2" xl="2" xs="6" sm="6">
                        <div class="mb-1">
                          <h6 class="mb-0">
                            Positions : {{ jobData.no_of_vacancies }}
                          </h6>
                          <span class="card-text"
                            >Open: {{ jobData.opened }} | Closed:
                            {{ jobData.closed }}</span
                          >
                        </div>
                      </b-col>
                      <b-col md="2" xl="2" xs="6" sm="6">
                        <div class="mb-1">
                          <b-avatar-group size="32px">
                            <b-avatar
                              v-for="(recruit, index) in jobData.recruiters"
                              :key="'B' + index"
                              v-b-tooltip.hover
                              class="pull-up"
                              :title="recruit.title"
                              variant="light-primary"
                              :text="avatarText(recruit.title)"
                            />
                          </b-avatar-group>
                        </div>
                      </b-col>
                      <b-col md="2" xl="2" xs="6" sm="6" v-if="jobData.sourcer">
                        <div class="mb-1">
                          <b-avatar-group size="32px">
                            <b-avatar
                              v-for="(source, index) in jobData.sourcer"
                              :key="'C' + index"
                              v-b-tooltip.hover
                              class="pull-up"
                              :title="source.title"
                              variant="light-primary"
                              :text="avatarText(source.title)"
                            />
                          </b-avatar-group>
                        </div>
                      </b-col>
                      <b-col md="2" xl="2" xs="6" sm="6">
                        <div
                          class="mb-1"
                        >
                          <h6 class="mb-0">
                            {{ jobData.account_mgr }}
                          </h6>
                        </div>
                      </b-col>
                      <div>
                        
                      </div>
                      <div v-if="$can('update','jobs')"
                        style="margin-left: auto; margin-right: 0; text-align: right; padding-right: 10px;"
                      >
                        <router-link :to="'/apps/edit-job/' + jobData.id" v-if="$can('update','jobs')">
                          <feather-icon
                            icon="EditIcon"
                            size="18"
                            class="mr-50"
                          />
                        </router-link>
                        <b-dropdown v-if="$can('read','jobs')"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                          right
                        >
                          <template v-slot:button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="text-body align-middle mr-25"
                            />
                          </template>
                          <b-dropdown-item v-if="$can('manage','job_status')"
                            @click="showModal(jobData.job_id, jobData.status)"
                          >
                            <feather-icon icon="Edit2Icon" class="mr-50" />
                            <span>Update Status</span>
                          </b-dropdown-item>
                          <b-dropdown-item v-if="$can('create','job_notes')"
                            @click="showModalNotes(jobData.id)"
                          >
                            <feather-icon icon="ClipboardIcon" class="mr-50" />
                            <span>Add Notes</span>
                          </b-dropdown-item>
                          <!-- <b-dropdown-item v-if="$can('read','jobs')"
                            @click="downloadJobtracker(jobData.id)"
                          >
                            <feather-icon icon="ClipboardIcon" class="mr-50" />
                            <span>Download Job Tracker</span>
                          </b-dropdown-item>
                          
                          
                          <b-dropdown-item v-if="$can('read','jobs')"
                            @click="downloadClientTracker(jobData.id)"
                          >
                            <feather-icon icon="ClipboardIcon" class="mr-50" />
                            <span>Download Today's Client Tracker</span>
                          </b-dropdown-item>

                          <b-dropdown-item v-if="$can('read','jobs')"
                            @click="showCustomDateModal"
                          >
                            <feather-icon icon="CalendarIcon" class="mr-50" />
                            <span>Download Custom Date Client Tracker</span>
                          </b-dropdown-item> -->
                          
                          <!--<b-dropdown-item @click="showModalNotes(job.job_id)">
                    <feather-icon icon="ClipboardIcon" class="mr-50" />
                    <span>Archive Job</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModalNotes(job.job_id)">
                    <feather-icon icon="ClipboardIcon" class="mr-50" />
                    <span>Clone Job</span>
                  </b-dropdown-item>-->
                        </b-dropdown>
                      </div>
                      
                      
                    </b-row>

                    <b-row
                      style="color: #5e5873 !important;font-size: 1rem;padding-top: 10px;"
                    >
                      <b-col md="3" xl="3" xs="6" class="mb-1">
                        <div class="d-flex flex-column ml-1">
                          <div class="mb-1">
                            <span class="text-muted"> Point of Contact </span>
                            <h6 class="mb-0">
                              {{ jobData.poc }} 
                            </h6>
                            <span class="card-text" v-if="jobData.business || jobData.sub_business"
                            >{{ jobData.business.title || jobData.business }} <span v-if="jobData.sub_business"> -  {{ jobData.sub_business.title || jobData.sub_business }}</span></span>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="3" xl="3" xs="6" class="mb-1">
                        <div class="d-flex flex-column ml-1">
                          <div class="mb-1">
                            <span class="text-muted"> Experience </span>
                            <h6 class="mb-0">
                              {{ jobData.min_exp }} -
                              {{ jobData.max_exp }} years
                            </h6>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="3" xl="3" xs="6" class="mb-1">
                        <div class="d-flex flex-column ml-1">
                          <div class="mb-1">
                            <span class="text-muted"> CTC </span>
                            <h6 class="mb-0">
                              ₹ {{ jobData.min_ctc }} - {{ jobData.max_ctc }} <span v-if="!blueCollar">Lacs</span>
                            </h6>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="3" xl="3" xs="6" class="mb-1">
                        <div class="d-flex flex-column ml-1">
                          <div class="mb-1">
                            <span class="text-muted"> Notice Period </span>
                            <h6 class="mb-0">
                              {{ jobData.notice_period }} Days
                            </h6>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="3" xl="3" xs="6" class="mb-1" v-if="jobData.drive_name">
                        <div class="d-flex flex-column ml-1">
                          <div class="mb-1">
                            <span class="text-muted"> Drive Name </span>
                            <h6 class="mb-0">{{ jobData.drive_name }}</h6>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="3" xl="3" xs="6" class="mb-1">
                        <div class="d-flex flex-column ml-1">
                          <div class="mb-1">
                            <span class="text-muted"> Target Date </span>
                            <h6 class="mb-0">
                              {{ formatJobDate(jobData.target_date) }}
                            </h6>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="3" xl="3" xs="6" class="mb-1">
                        <div class="d-flex flex-column ml-1">
                          <div class="mb-1">
                            <span class="text-muted"> Added By </span>
                            <h6 class="mb-0">
                              {{ displayNameFromField(jobData.created_by) }}
                            </h6>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="6" xl="6" xs="6" class="mb-1">
                        <div class="d-flex flex-column ml-1">
                          <div class="mb-1">
                            <span class="text-muted"> Desired Skills </span>
                            <h6 class="mb-0">
                              {{ jobData.desired_skills }}
                            </h6>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>

                <!--<candidate-list-add-new-old :job-data="jobData"  @refreshParent="updateParent" />-->
                <div class="d-flex demo-inline-spacing align-items-center justify-content-end content-sidebar-header px-2 py-1" v-if="$can('create', 'candidates') && jobData.status !== 'Approval Pending'">
    
                  
                
                <b-button  @click="openAddJobSourcerPage" variant="outline-primary" class="px-2 py-1" v-if="$can('create','candidates')">Add Candidates</b-button>
                
                <candidate-list-add-new :key="jobData.id || id" :job-info="jobData" @refreshParent="updateParent"/>
                <b-button  variant="primary" class="px-2 py-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                v-b-modal.modal-check-exist-in-db
                                v-b-tooltip.hover.bottom="'Check The Candidate in ATS Before Opening/Viewing the Contact Details in Naukri'">Check In DB</b-button>
                <b-button
                  v-if="hasDialerAccess"
                  variant="outline-success"
                  class="px-2 py-1"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  @click="$bvModal.show('modal-outbound-dialer')"
                >
                  <feather-icon icon="PhoneCallIcon" class="mr-50" />
                  Dialer
                </b-button>
                <b-button
                  v-if="showAiCallingTab"
                  variant="outline-info"
                  class="px-2 py-1"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  @click="openAiCallingTab"
                >
                  <feather-icon icon="CpuIcon" class="mr-50" />
                  AI Calling
                </b-button>
       
                </div>
                
                
                
                
                
                <div v-if="jobData.status !== 'Approval Pending'">
                  <div class="demo-inline-spacing">
                    <h2>Candidates Pool</h2>
                    
                    
                    
                    
                    <!-- Status Summary End -->
                    <div class="text-right">
                      <span > Filter by: </span>
                      <span><b-badge pill class="text-capitalize btn-outline-info mr-2" id="badge-all"
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              @click="filterCandidate('all')"> All Candidates </b-badge>
                      </span>
                      <span><b-badge pill class="text-capitalize btn-outline-info " id="badge-my"
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              @click="filterCandidate('my')"> Added By Me </b-badge>
                      </span>
                        </div>
                  </div>
                  <!-- Status Summary Start -->
                  <app-collapse :title="'Status Summary'" :content="candidateStatusSummary" >
                      <app-collapse-item title="Status Summary" class="text-primary">
                        <div class="d-flex flex-wrap mb-2">
                          <div
                            v-for="(count, status) in candidateStatusSummary"
                            :key="status"
                            
                          >
                            <b-badge
                              pill :variant="resolveCandidateStatusVariant(status)"
                              :class="resolveCandidateStatusVariant(status)"
                              class="mb-1"
                              style="font-size: 0.7rem;"
                            >
                              {{ status }}
                            </b-badge>
                            <span class="text-bold" style="font-size: 0.9rem;">  : {{ count }}  &nbsp;&nbsp;</span>
                          </div>
                        </div>    
                      </app-collapse-item>
                     </app-collapse> 
                  <b-card no-body class="mb-0" lazy>
                    <div class="m-2">
                      <!-- Show tabs only for KPMG-RPO -->
                      <template v-if="isKPMGRPO">
                      <b-tabs>
                        <!-- All Candidates Tab -->
                        <b-tab title="All" active>
                          <b-row class="mt-1">
                            <b-col cols="12" md="6">
                              <label>Show</label>
                              <v-select
                                v-model="perPage"
                                :options="perPageOptions"
                                :clearable="false"
                                class="per-page-selector d-inline-block"
                              />
                              <label> of <b>{{ fetchCandidates.length }}</b> entries</label>
                            </b-col>
                            <b-col cols="12" md="6">
                              <div class="d-flex align-items-center justify-content-end">
                                <b-form-input
                                  v-model="filter"
                                  class="d-inline-block mr-1"
                                  placeholder="Search..."
                                  trim
                                />
                        </div>
                            </b-col>
                          </b-row>

                          <b-table
                            ref="refCandidateListTable"
                            :items="fetchCandidates"
                            v-bind="$attrs"
                            v-on="$listeners"
                            :fields="tableColumns"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :filter="filter"
                            :busy="candidatesLoading"
                            show-empty
                            empty-text="No candidates in this pool"
                          >
                            <template #table-busy>
                              <div class="text-center my-2">
                                <b-spinner small variant="primary" />
                                <span class="ml-50">Loading candidates…</span>
                              </div>
                            </template>
                            <!-- Column: Candidate -->
                            <template #cell(id)="data">
                                <b-media vertical-align="center">
                                  <b-link
                                :to="{
                                  name: 'apps-candidates-view',
                                      params: { id: data.item.id, jobId: jobData.id },
                                  query: { position_name: jobData.position_name,
                                          client: jobData.client,
                                          attachments: jobData.attachments,
                                                recruiter: data.item.recruiter,
                                          locations: jobData.locations,
                                                sourcer: poolLinkSourcer(data.item),
                                                am_name: jobData.account_mgr, job_id: jobData.job_id,
                                                page: currentPage,
                                                position_type: jobData.type,
                                                vertical: jobData.vertical,
                                                category: jobData.category,
                                                payroll: jobData.payroll
                                        }
                                    }"
                                    class="font-weight-bold d-block text-nowrap text-capitalize"
                                  >
                                    <span v-b-tooltip.hover.bottom="data.item.full_name">
                                      {{ data.item.full_name.length > 20 ? data.item.full_name.substring(0, 20) + '...' : data.item.full_name }}
                                    </span> <br />
                                    {{ data.item.candidate_id }}
                                  </b-link>
                                  <span class="text-small" style="color:#a7a6aa; font-size: 12px">
                                    Added on {{ formatJobDate(data.item.createdAt) }}</span>
                                </b-media>
                            </template>

                            <!-- Column: Contact -->
                            <template #cell(email)="data">
                              <div class="text-nowrap">
                                <span class="align-text-top">{{ data.item.email }}</span><br />
                                <span class="align-text-top">{{ data.item.contact_no }}</span>
                                <br />
                                <b-button
                                  v-if="canMakeCall && data.item.contact_no"
                                  variant="flat-success"
                                  size="sm"
                                  class="p-25"
                                  v-b-tooltip.hover.bottom="'Dial ' + data.item.contact_no"
                                  @click.stop="openOutboundDialer(data.item.contact_no)"
                                >
                                  <feather-icon icon="PhoneIcon" size="14" />
                                </b-button>
                                </div>
                            </template>

                            <!-- Column: Location -->
                            <template #cell(curr_location)="data">
                              <div class="text-wrap"  v-if="data.item.curr_location">
                                <span v-b-tooltip.hover.bottom="data.item.curr_location">
                                {{ data.item.curr_location.length > 30 ? data.item.curr_location.substring(0, 30) + '...' : data.item.curr_location }}
                              </span>
                              </div>  
                            </template>

                            <template #cell(sourcer_name)="data">
                              <div class="pool-sr-cell">
                                <div class="pool-sr-people">
                                  <div v-if="poolResolvedSourcerName(data.item)" class="pool-sr-row text-nowrap">
                                    <b-avatar
                                      v-b-tooltip.hover
                                      :title="'Sourcer: ' + poolResolvedSourcerName(data.item)"
                                      class="mr-50"
                                      size="24"
                                      :text="poolRoleAvatarText('S')"
                                      variant="light-info"
                                    />
                                    <span class="align-text-top text-capitalize">{{ poolResolvedSourcerName(data.item) }}</span>
                                  </div>
                                  <div v-if="poolResolvedRecruiterName(data.item)" class="pool-sr-row text-nowrap">
                                    <b-avatar
                                      v-b-tooltip.hover
                                      :title="'Recruiter: ' + poolResolvedRecruiterName(data.item)"
                                      class="mr-50"
                                      size="24"
                                      :text="poolRoleAvatarText('R')"
                                      variant="light-success"
                                    />
                                    <span class="align-text-top text-capitalize">{{ poolResolvedRecruiterName(data.item) }}</span>
                                  </div>
                                <div v-if="poolResolvedSourceChannel(data.item)" class="pool-source-wrap">
                                  <span class="pool-source-chip">{{ poolResolvedSourceChannel(data.item) }}</span>
                                </div>
                                </div>
                              </div>
                            </template>

                            <!-- Column: Status -->
                            <template #cell(status)="data">
                              <span class="demo-inline-spacing">
                                <b-badge 
                                  pill 
                                  class="text-capitalize" 
                                  :id="'badgeshow_' + data.item.id"
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  v-b-tooltip.hover.bottom="data.item.candidateStatus === 'Not Interested' ? 'Reason: ' + data.item.reason + ' Comment: ' + data.item.comment : data.item.candidateStatus === 'Not Relevant' || data.item.candidateStatus === 'Call Back' ? ' Comment: ' + data.item.comment : ''"
                                  :class="resolveCandidateStatusVariant(data.item.candidateStatus)"
                                >
                                  {{ data.item.candidateStatus }}<br>
                                </b-badge>
                                <b-badge 
                                  pill 
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                                  v-if="data.item.extra_details && data.item.extra_details.test_status"
                                > 
                                  {{ data.item.extra_details.test_status }} | {{ data.item.extra_details.test_score}}
                                </b-badge>
                              </span>
                            </template>

                            <!-- Column: Actions -->
                            <template #cell(actions)="data">
                              <span v-if="data.item.extra_details && data.item.extra_details.test_status"> 
                                <span v-if="data.item.extra_details.test_status === 'Test Select' ">
                                  <feather-icon
                                    icon="CalendarIcon"
                                    size="16"
                                    class="align-middle text-primary cursor-pointer"
                                    @click="openScheduleInterviewModal(data.item)"
                                  />
                                </span>
                              </span>
                              <b-dropdown
                                variant="link"
                                no-caret
                                :right="$store.state.appConfig.isRTL"
                                boundary="window"
                                :popper-opts="{ positionFixed: true }"
                                menu-class="jobs-view-actions-dropdown"
                                @show="hoistActionsDropdownMenu"
                                @hidden="restoreActionsDropdownMenu"
                              >
                                <template #button-content>
                                  <feather-icon
                                    icon="MoreVerticalIcon"
                                    size="16"
                                    class="align-middle text-body"
                                  />
                                </template>

                                <b-dropdown-item 
                                :to="{
                                    name: 'apps-candidates-edit',
                                    params: { id: data.item.id, jobId: jobData.id },
                                    query: { candidateStatus: data.item.candidateStatus },
                                  }"
                                >
                                  <feather-icon icon="EditIcon" />
                                  <span class="align-middle ml-50">Edit Profile</span>
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-if="isInActionCandidate(data.item)"
                                  @click.prevent="openUpdateResume(data.item)"
                                >
                                  <feather-icon icon="UploadIcon" />
                                  <span class="align-middle ml-50">Update Resume</span>
                                </b-dropdown-item>
                                <b-dropdown-item
                                  v-else
                                  @click.prevent="startResumeUpload(data.item)"
                                >
                                  <feather-icon icon="UploadIcon" />
                                  <span class="align-middle ml-50">Upload Resume</span>
                                </b-dropdown-item>
                              </b-dropdown>
                            </template>
                          </b-table>

                          <!-- Pagination -->
                          <div class="mx-2">
                      <b-row>
                              <b-col cols="12">
                                <b-pagination
                                  v-model="currentPage"
                                  :total-rows="fetchCandidates.length"
                                  :per-page="perPage"
                                  align="center"
                                  size="sm"
                                  class="my-0 mb-2"
                                  @change="onPageChange"
                                />
                              </b-col>
                            </b-row>
                        </div>
                        </b-tab>

                        <!-- Dynamic Business Tabs -->
                        <b-tab 
                          v-for="business in businessTabs" 
                          :key="business"
                          :title="business"
                        >
                          <b-row class="mt-1">
                            <b-col cols="12" md="6">
                          <label>Show</label>
                          <v-select
                            v-model="perPage"
                            :options="perPageOptions"
                            :clearable="false"
                            class="per-page-selector d-inline-block"
                          />
                              <label> of <b>{{ getBusinessCandidates(business).length }}</b> entries</label>
                            </b-col>
                            <b-col cols="12" md="6">
                              <div class="d-flex align-items-center justify-content-end">
                                <b-form-input
                                  v-model="filter"
                                  class="d-inline-block mr-1"
                                  placeholder="Search..."
                                  trim
                                />
                                </div>
                            </b-col>
                          </b-row>

                          <b-table
                            ref="refCandidateListTable"
                            :items="getBusinessCandidates(business)"
                            v-bind="$attrs"
                            v-on="$listeners"
                            :fields="tableColumns"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :filter="filter"
                            :busy="candidatesLoading"
                            show-empty
                            empty-text="No candidates in this pool"
                          >
                            <template #table-busy>
                              <div class="text-center my-2">
                                <b-spinner small variant="primary" />
                                <span class="ml-50">Loading candidates…</span>
                              </div>
                            </template>
                            <!-- Column: Candidate -->
                            <template #cell(id)="data">
                                <b-media vertical-align="center">
                                  <b-link
                                :to="{
                                  name: 'apps-candidates-view',
                                      params: { id: data.item.id, jobId: jobData.id },
                                  query: { position_name: jobData.position_name,
                                          client: jobData.client,
                                          attachments: jobData.attachments,
                                                recruiter: data.item.recruiter,
                                          locations: jobData.locations,
                                                sourcer: poolLinkSourcer(data.item),
                                                am_name: jobData.account_mgr, job_id: jobData.job_id,
                                                page: currentPage,
                                                position_type: jobData.type,
                                                vertical: jobData.vertical,
                                                category: jobData.category,
                                                payroll: jobData.payroll
                                        }
                                    }"
                                    class="font-weight-bold d-block text-nowrap text-capitalize"
                                  >
                                    <span v-b-tooltip.hover.bottom="data.item.full_name">
                                      {{ data.item.full_name.length > 20 ? data.item.full_name.substring(0, 20) + '...' : data.item.full_name }}
                                    </span> <br />
                                    {{ data.item.candidate_id }}
                                    
                                  </b-link>
                                  <span class="text-small" style="color:#a7a6aa; font-size: 12px">
                                    Added on {{ formatJobDate(data.item.createdAt) }}</span>
                                </b-media>
                              </template>

                              <!-- Column: Contact -->
                              <template #cell(email)="data">
                                <div class="text-nowrap">
                                  <span class="align-text-top ">{{
                                    data.item.email
                                  }}</span
                                  ><br />
                                  <span class="align-text-top ">{{
                                    data.item.contact_no
                                  }}</span>
                                  <br />
                                  <b-button
                                    v-if="canMakeCall && data.item.contact_no"
                                    variant="flat-success"
                                    size="sm"
                                    class="p-25"
                                    v-b-tooltip.hover.bottom="'Dial ' + data.item.contact_no"
                                    @click.stop="openOutboundDialer(data.item.contact_no)"
                                  >
                                    <feather-icon icon="PhoneIcon" size="14" />
                                  </b-button>
                        </div>
                              </template>

                              <!-- Column: Location -->
                              <template #cell(curr_location)="data">
                                <div class="text-wrap" v-b-tooltip.hover.bottom="data.item.curr_location">
                                  {{ data.item.curr_location.length > 30 ? data.item.curr_location.substring(0, 30) + '...' : data.item.curr_location }}
                        </div>
                              </template>
                              <template #cell(sourcer_name)="data">
                                <div class="pool-sr-cell">
                                  <div class="pool-sr-people">
                                    <div v-if="poolResolvedSourcerName(data.item)" class="pool-sr-row text-nowrap">
                                      <b-avatar
                                        v-b-tooltip.hover
                                        :title="'Sourcer: ' + poolResolvedSourcerName(data.item)"
                                        class="mr-50"
                                        size="24"
                                        :text="poolRoleAvatarText('S')"
                                        variant="light-info"
                                      />
                                      <span class="align-text-top text-capitalize">{{ poolResolvedSourcerName(data.item) }}</span>
                                    </div>
                                    <div v-if="poolResolvedRecruiterName(data.item)" class="pool-sr-row text-nowrap">
                                      <b-avatar
                                        v-b-tooltip.hover
                                        :title="'Recruiter: ' + poolResolvedRecruiterName(data.item)"
                                        class="mr-50"
                                        size="24"
                                        :text="poolRoleAvatarText('R')"
                                        variant="light-success"
                                      />
                                      <span class="align-text-top text-capitalize">{{ poolResolvedRecruiterName(data.item) }}</span>
                                    </div>
                                  <div v-if="poolResolvedSourceChannel(data.item)" class="pool-source-wrap">
                                    <span class="pool-source-chip">{{ poolResolvedSourceChannel(data.item) }}</span>
                                  </div>
                                  </div>
                                </div>
                              </template>
                              <!-- Column: Status -->
                              <template #cell(status)="data">
                              <span class="demo-inline-spacing">
                                <b-badge pill class="text-capitalize" :id="'badgeshow_' + data.item.id"
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                v-b-tooltip.hover.bottom="data.item.candidateStatus === 'Not Interested' ? 'Reason: ' + data.item.reason + ' Comment: ' + data.item.comment : data.item.candidateStatus === 'Not Relevant' || data.item.candidateStatus === 'Call Back' ? ' Comment: ' + data.item.comment : ''"
                                :class="resolveCandidateStatusVariant(data.item.candidateStatus)">
                                
                                  {{ data.item.candidateStatus }}<br>
                                  
                                </b-badge>
                                  <b-badge pill v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-if="data.item.extra_details && data.item.extra_details.test_status"> {{ data.item.extra_details.test_status }} | {{ data.item.extra_details.test_score}}</b-badge>
                                  <!-- <b-link
                                    href="#"
                                    class="ml-1"
                                    v-b-modal="'modal-extra-details-' + data.item.id"
                                  >
                                    <feather-icon 
                                      icon="InfoIcon"
                                      size="14"
                                      class="text-primary"
                                      v-b-tooltip.hover.bottom="data.item.extra_details"
                                    />
                                  </b-link> -->

                                
                                  
                                  <!-- <span :id="'edit_' + data.item.id" class="py-1" v-if="data.item.candidateStatus !== 'Uploaded' && data.item.candidateStatus !== 'UploadedBySourcer' && data.item.candidateStatus !== 'UploadedByRecruiter' && data.item.candidateStatus !== 'AssignedByMassMail' && data.item.candidateStatus !== 'Initiated' && data.item.candidateStatus !== 'Not Interested' && data.item.candidateStatus !== 'Not Answered' && data.item.candidateStatus !== 'Not Relevant' && data.item.candidateStatus !== 'Not Reachable' && data.item.candidateStatus !== 'Call Back' && data.item.candidateStatus !== 'Wrong Number'"
                                  @click="updateClick(data.item, jobData.id, data.item.candidateStatus )">
                                    <feather-icon icon="EditIcon" variant="outline-primary" />
                                  </span> -->
                                
                              
                              </span>
                                
                              </template>

                              <!-- Column: Actions -->
                              <template #cell(actions)="data">
                                <b-dropdown
                                  variant="link"
                                  no-caret
                                  :right="$store.state.appConfig.isRTL"
                                  boundary="window"
                                  :popper-opts="{ positionFixed: true }"
                                  menu-class="jobs-view-actions-dropdown"
                                  @show="hoistActionsDropdownMenu"
                                  @hidden="restoreActionsDropdownMenu"
                                >
                                  <template #button-content>
                                    <feather-icon
                                      icon="MoreVerticalIcon"
                                      size="16"
                                      class="align-middle text-body"
                                    />
                                  </template>
                                  

                                  <b-dropdown-item 
                                :to="{
                                      name: 'apps-candidates-edit',
                                      params: { id: data.item.id, jobId: jobData.id },
                                      query: { candidateStatus: data.item.candidateStatus },
                                    }"
                                  >
                                    <feather-icon icon="EditIcon" />
                                    <span class="align-middle ml-50">Edit Profile</span>
                                  </b-dropdown-item>
                                  <b-dropdown-item
                                    v-if="isInActionCandidate(data.item)"
                                    @click.prevent="openUpdateResume(data.item)"
                                  >
                                    <feather-icon icon="UploadIcon" />
                                    <span class="align-middle ml-50">Update Resume</span>
                                  </b-dropdown-item>
                                  <b-dropdown-item
                                    v-else
                                    @click.prevent="startResumeUpload(data.item)"
                                  >
                                    <feather-icon icon="UploadIcon" />
                                    <span class="align-middle ml-50">Upload Resume</span>
                                  </b-dropdown-item>
                                  <!-- <b-dropdown-item v-if="candidateStatus === 'UploadedBySourcer' && candidateStatus === 'Initiated' && candidateStatus === 'UploadedByRecruiter' && candidateStatus === 'AssignedByATSSourcer' && candidateStatus === 'AssignedByMassMail' && candidateStatus === 'Not Interested' && candidateStatus === 'Not Relevant' && candidateStatus === 'Not Answered' && candidateStatus === 'Not Reachable' && candidateStatus === 'Not Answered' && candidateStatus === 'Call Back' && candidateStatus === 'Wrong Number'"
                                    @click="shareJD(jobData.attachments)"
                                  >
                                    <feather-icon icon="EditIcon" />
                                    <span class="align-middle ml-50">Share JD</span>
                                  </b-dropdown-item> -->
                                  <!-- <b-dropdown-item
                                    @click="showRemoveCandidateModal(data.item.id, jobData.id)"
                                  >
                                    <feather-icon icon="TrashIcon" />
                                    <span class="align-middle ml-50">Remove From this Job</span>
                                  </b-dropdown-item> -->
                                  <!--<b-dropdown-item @click="showCModal(data.item.id)">
                                    <feather-icon icon="EditIcon" />
                                    <span class="align-middle ml-50">Update Status</span>
                                  </b-dropdown-item>-->
                                </b-dropdown>
                          </template>
                          </b-table>

                          <!-- Pagination -->
                          <div class="mx-2">
                            <b-row>
                              <b-col cols="12">
                                <b-pagination
                            v-model="currentPage"
                                  :total-rows="getBusinessCandidates(business).length"
                                  :per-page="perPage"
                                  align="center"
                                  size="sm"
                                  class="my-0 mb-2"
                            @change="onPageChange"
                                />
                        </b-col>
                            </b-row>
                        </div>
                        </b-tab>
                        <b-tab title="Verify Profiles"  v-if="todaysCandidates && isVerifier(empId)">
                          <b-row class="mt-1">
                        <b-col cols="12" md="6">
                              <label>Show</label>
                              <v-select
                                v-model="perPage"
                                :options="perPageOptions"
                            :clearable="false"
                                class="per-page-selector d-inline-block"
                              />
                              <label> of <b>{{ todaysCandidates.length }}</b> entries</label>
                            </b-col>
                            <b-col cols="12" md="6">
                              <div class="d-flex align-items-center justify-content-end">
                                <b-form-input
                                  v-model="filter"
                                  class="d-inline-block mr-1"
                                  placeholder="Search..."
                                  trim
                                />
                              </div>
                            </b-col>
                          </b-row>

                          <b-table
                            ref="refCandidateListTable"
                            :items="todaysCandidates"
                            v-bind="$attrs"
                            v-on="$listeners"
                            :fields="VerifyProfileColumns"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :filter="filter"
                            :busy="candidatesLoading"
                            show-empty
                            empty-text="No candidates to verify"
                          >
                            <template #table-busy>
                              <div class="text-center my-2">
                                <b-spinner small variant="primary" />
                                <span class="ml-50">Loading candidates…</span>
                              </div>
                            </template>
                            <!-- Column: Candidate -->
                            <template #cell(id)="data">
                                <b-media vertical-align="center">
                                  <b-modal
                                    :id="'candidate-modal-' + data.item.id"
                                    size="xl"
                                    scrollable
                                    hide-footer
                                    :title="data.item.first_name + ' ' + data.item.last_name"
                                  >
                                    <b-row>
                                      <b-col cols="12" class="mb-2">
                                        <h5>Candidate Details</h5>
                                      </b-col>
                                      <b-col cols="4" class="mb-2"><strong>Name:</strong> {{ data.item.first_name }} {{ data.item.last_name }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Email:</strong> {{ data.item.email }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Contact:</strong> {{ data.item.contact_no }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Current Location:</strong> {{ data.item.curr_location }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Current Company:</strong> {{ data.item.curr_company }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Current Designation:</strong> {{ data.item.curr_postion }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Experience:</strong> {{ data.item.exp }} years</b-col>
                                      <b-col cols="4" class="mb-2"><strong>CTC:</strong> ₹{{ data.item.ctc }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Notice Period:</strong> {{ data.item.notice_period }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Gender:</strong> {{ data.item.gender }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Source:</strong> {{ data.item.source }}</b-col>
                                      <b-col cols="4" class="mb-2"><strong>Added On:</strong> {{ formatJobDate(data.item.createdAt) }}</b-col>
                                    </b-row>
                                    <b-row class="mt-2">
                                      <b-col cols="12" class="mb-2">
                                        <h5>KPMG RPO Details</h5>
                                      </b-col>
                                      <b-col
                                        v-for="(value, key) in data.item.extra_details"
                                        :key="key"
                                        cols="4"
                                        class="mb-2"
                                        
                                      >
                                        <strong>{{ formatKey(key) }}:</strong> {{ value }}
                                      </b-col>
                                      <!-- Timeline for transition key -->
                                      <!-- <div v-if="data.item.extra_details.transition">
                                        <b-col cols="12" v-if="data.item.extra_details.transition && data.item.extra_details.transition.length">
                                          <h6 class="mt-2 mb-1">Transition Timeline</h6>
                                          <ul class="timeline pl-2">
                                            <li v-for="(t, idx) in data.item.extra_details.transition" :key="idx" class="mb-2">
                                              <div>
                                                <span v-if="t.businessFrom || t.businessTo">
                                                  <b>Business:</b>
                                                  <span v-if="t.businessFrom"> {{ t.businessFrom }} </span>
                                                  <span v-if="t.businessFrom && t.businessTo">→</span>
                                                  <span v-if="t.businessTo"> {{ t.businessTo }} </span>
                                                  <br>
                                                </span>
                                                <span v-if="t.levelFrom || t.levelTo">
                                                  <b>Level:</b>
                                                  <span v-if="t.levelFrom"> {{ t.levelFrom }} </span>
                                                  <span v-if="t.levelFrom && t.levelTo">→</span>
                                                  <span v-if="t.levelTo"> {{ t.levelTo }} </span>
                                                  <br>
                                                </span>
                                                <span v-if="t.transitionOn"><b>Date:</b> {{ t.transitionOn | formatDate }}</span>
                                                <span v-if="t.transitionBy"><b> By:</b> {{ t.transitionBy }}</span>
                                </div>
                                            </li>
                                          </ul>
                                        </b-col>
                                      </div> -->
                                    </b-row>
                                    <b-row class="mt-2">
                                      <b-col cols="12">
                                        <h5>Resume Preview</h5>
                                        <span v-if="!pdf || !docx || !doc || !rtf || !otherDoc">
                                           <b-button variant="primary" @click="previewCV(data.item.cv_path, false)">Preview CV</b-button>
                                        </span>
                                        <div>
                                          <div v-if="pdf">
                                            <iframe :src="blink" frameborder="0" height="1200px" width="100%"></iframe>
                                          </div>
                                          <div v-if="docx || doc">
                                            <a class="text-center font-weight-bolder" :href="mlink" target="_blank" v-if="docx || doc"> Preview CV</a>
                                            <iframe :src="mlink" frameborder="0" height="1200px" width="100%"></iframe>
                                          </div>
                                          <div v-if="rtf">
                                            <iframe :src="glink" frameborder="0" height="1200px" width="100%"></iframe>
                                          </div>
                                          <div v-if="otherDoc">
                                            <iframe :src="mlink" frameborder="0" height="1200px" width="100%"></iframe>
                                          </div>
                                        </div>
                                      </b-col>
                                    </b-row>
                                  </b-modal>
          
                                  <b-button
                                    variant="link"
                                    class="font-weight-bold d-block text-nowrap text-capitalize p-0"
                                    @click="$bvModal.show('candidate-modal-' + data.item.id)"
                                  >
                                    <span v-b-tooltip.hover.bottom="data.item.first_name + ' ' + data.item.last_name">
                                      {{ (data.item.first_name + ' ' + data.item.last_name).length > 20 ? (data.item.first_name + ' ' + data.item.last_name).substring(0, 20) + '...' : data.item.first_name + ' ' + data.item.last_name }}
                                    </span> <br />
                                    {{ data.item.candidate_id }}
                                  </b-button>
                                  <span class="text-small" style="color:#a7a6aa; font-size: 12px">
                                    Added on {{ formatJobDate(data.item.createdAt) }}</span>
                                </b-media>
                            </template>

                            <!-- Column: Contact -->
                            <template #cell(email)="data">
                              <div class="text-nowrap">
                                <span class="align-text-top">{{ data.item.email }}</span><br />
                                <span class="align-text-top">{{ data.item.contact_no }}</span>
                        </div>
                            </template>

                            <template #cell(status)="data">
                              <span class="demo-inline-spacing">
                                <b-badge 
                                  pill 
                                  class="text-capitalize" 
                                  :id="'badgeshow_' + data.item.id"
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  v-b-tooltip.hover.bottom="data.item.candidateStatus === 'Not Interested' ? 'Reason: ' + data.item.reason + ' Comment: ' + data.item.comment : data.item.candidateStatus === 'Not Relevant' || data.item.candidateStatus === 'Call Back' ? ' Comment: ' + data.item.comment : ''"
                                  :class="resolveCandidateStatusVariant(data.item.candidateStatus)"
                                >
                                  {{ data.item.candidateStatus }}<br>
                                </b-badge>
                                <b-badge 
                                  pill 
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  v-if="data.item.extra_details && data.item.extra_details.test_status"
                                > 
                                  {{ data.item.extra_details.test_status }} | {{ data.item.extra_details.test_score}}
                                </b-badge>
                              </span>
                            </template> 

                            <template #cell(extra_details)="data">
                              <div class="inline-spacing" v-if="data.item.extra_details">
                                <v-select
                                  v-model="data.item.extra_details.business"
                                  :options="businessOptions"
                                  label="title"
                                  :reduce="(option) => option.title"
                                  placeholder="Select Business"
                                  
                                />
                                <v-select
                                  v-model="data.item.extra_details.level"
                                  :options="levelOptions"
                                  label="title"
                                  :reduce="(option) => option.title"
                                  placeholder="Select Level"
                                />
                                <b-form-input
                                  v-model="data.item.extra_details.verifierScore"
                                  type="number"
                                  placeholder="Enter Verifier score"
                                />
                        </div>

                            </template>

                            <!-- <template #cell(extra_details)="data">
                                
                            </template> -->

                            <!-- Column: Actions -->
                            <template #cell(actions)="data">
                              <div class="d-flex align-items-center">
                                <feather-icon
                                  icon="CheckCircleIcon"
                                  class="text-success cursor-pointer mr-1"
                                  size="20"
                                  v-b-tooltip.hover.bottom="'Verify'"
                                  @click="updateVerification('verified', data.item)"
                                />
                                <feather-icon
                                  icon="XCircleIcon"
                                  class="text-danger cursor-pointer"
                                  size="20"
                                  v-b-tooltip.hover.bottom="'Reject'"
                                  @click="updateVerification('rejected', data.item)"
                                />
                              </div>
                      </template>
                          </b-table>

                          <!-- Pagination -->
                          <div class="mx-2">
                            <b-row>
                              <b-col cols="12">
                                <b-pagination
                                  v-model="currentPage"
                                  :total-rows="todaysCandidates.length"
                                  :per-page="perPage"
                                  align="center"
                                  size="sm"
                                  class="my-0 mb-2"
                            @change="onPageChange"
                                />
                        </b-col>
                            </b-row>
                      </div>
                    </b-tab>
                  </b-tabs>
                      </template>

              <!-- Show regular table for other clients -->
                      <template v-else>
                      <b-row>
                        <b-col cols="12" md="6">
                          <label>Show</label>
                          <v-select
                            v-model="perPage"
                            :options="perPageOptions"
                            :clearable="false"
                            class="per-page-selector d-inline-block"
                          />
                          <label> of <b>{{ fetchCandidates.length }}</b> entries</label>
                        </b-col>
                        <b-col cols="12" md="6">
                            <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                              v-model="filter"
                              class="d-inline-block mr-1"
                              placeholder="Search..."
                              trim
                            />
                          </div>
                        </b-col>
                      </b-row>

                    <b-table
                      ref="refCandidateListTable"
                      :items="fetchCandidates"
                          v-bind="$attrs"
                          v-on="$listeners"
                      :fields="tableColumns"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :filter="filter"
                      :busy="candidatesLoading"
                      show-empty
                      empty-text="No candidates in this pool"
                    >
                      <template #table-busy>
                        <div class="text-center my-2">
                          <b-spinner small variant="primary" />
                          <span class="ml-50">Loading candidates…</span>
                        </div>
                      </template>
                      <!-- Column: Candidate -->
                      <template #cell(id)="data">
                        <b-media vertical-align="center">
                          <b-link
                            :to="{
                              name: 'apps-candidates-view',
                              params: { id: data.item.id, jobId: jobData.id },
                              query: { position_name: jobData.position_name,
                                         client: jobData.client,
                                         attachments: jobData.attachments,
                                         recruiter: data.item.recruiter,
                                         locations: jobData.locations,
                                         sourcer: poolLinkSourcer(data.item),
                                         am_name: jobData.account_mgr, job_id: jobData.job_id,
                                         page: currentPage,
                                         position_type: jobData.type,
                                         vertical: jobData.vertical,
                                         category: jobData.category,
                                         payroll: jobData.payroll
                                }
                            }"
                            class="font-weight-bold d-block text-nowrap text-capitalize"
                          >
                                    <span v-b-tooltip.hover.bottom="data.item.full_name">
                                      {{ data.item.full_name.length > 20 ? data.item.full_name.substring(0, 20) + '...' : data.item.full_name }}
                                    </span> <br />
                            {{ data.item.candidate_id }}
                            
                          </b-link>
                          <span class="text-small" style="color:#a7a6aa; font-size: 12px">
                            Added on {{ formatJobDate(data.item.createdAt) }}</span>
                        </b-media>
                      </template>

                      <!-- Column: Contact -->
                      <template #cell(email)="data">
                        <div class="text-nowrap">
                          <span class="align-text-top ">{{
                            data.item.email
                          }}</span
                          ><br />
                          <span class="align-text-top ">{{
                            data.item.contact_no
                          }}</span>
                          <br />
                          <b-button
                            v-if="canMakeCall && data.item.contact_no"
                            variant="flat-success"
                            size="sm"
                            class="p-25"
                            v-b-tooltip.hover.bottom="'Dial ' + data.item.contact_no"
                            @click.stop="openOutboundDialer(data.item.contact_no)"
                          >
                            <feather-icon icon="PhoneIcon" size="14" />
                          </b-button>
                        </div>
                      </template>

                      <!-- Column: Location -->
                      <template #cell(curr_location)="data">
                                <div class="text-wrap" v-b-tooltip.hover.bottom="data.item.curr_location">
                                  {{ data.item.curr_location.length > 30 ? data.item.curr_location.substring(0, 30) + '...' : data.item.curr_location }}
                        </div>
                      </template>
                      <template #cell(sourcer_name)="data">
                        <div class="pool-sr-cell">
                          <div class="pool-sr-people">
                            <div v-if="poolResolvedSourcerName(data.item)" class="pool-sr-row text-nowrap">
                              <b-avatar
                                v-b-tooltip.hover
                                :title="'Sourcer: ' + poolResolvedSourcerName(data.item)"
                                class="mr-50"
                                size="24"
                                :text="poolRoleAvatarText('S')"
                                variant="light-info"
                              />
                              <span class="align-text-top text-capitalize">{{ poolResolvedSourcerName(data.item) }}</span>
                            </div>
                            <div v-if="poolResolvedRecruiterName(data.item)" class="pool-sr-row text-nowrap">
                              <b-avatar
                                v-b-tooltip.hover
                                :title="'Recruiter: ' + poolResolvedRecruiterName(data.item)"
                                class="mr-50"
                                size="24"
                                :text="poolRoleAvatarText('R')"
                                variant="light-success"
                              />
                              <span class="align-text-top text-capitalize">{{ poolResolvedRecruiterName(data.item) }}</span>
                            </div>
                          <div v-if="poolResolvedSourceChannel(data.item)" class="pool-source-wrap">
                            <span class="pool-source-chip">{{ poolResolvedSourceChannel(data.item) }}</span>
                          </div>
                          </div>
                        </div>
                      </template>
                      <!-- Column: Status -->
                      <template #cell(status)="data">
                       <span class="demo-inline-spacing">
                        <b-badge pill class="text-capitalize" :id="'badgeshow_' + data.item.id"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        v-b-tooltip.hover.bottom="data.item.candidateStatus === 'Not Interested' ? 'Reason: ' + data.item.reason + ' Comment: ' + data.item.comment : data.item.candidateStatus === 'Not Relevant' || data.item.candidateStatus === 'Call Back' ? ' Comment: ' + data.item.comment : ''"
                        :class="resolveCandidateStatusVariant(data.item.candidateStatus)">
                        
                          {{ data.item.candidateStatus }}<br>
                          
                        </b-badge>
                          <b-badge pill v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-if="data.item.extra_details && data.item.extra_details.test_status"> {{ data.item.extra_details.test_status }} | {{ data.item.extra_details.test_score}}</b-badge>
                          <!-- <b-link
                            href="#"
                            class="ml-1"
                            v-b-modal="'modal-extra-details-' + data.item.id"
                          >
                            <feather-icon 
                              icon="InfoIcon"
                              size="14"
                              class="text-primary"
                              v-b-tooltip.hover.bottom="data.item.extra_details"
                            />
                          </b-link> -->

                        
                          
                          <!-- <span :id="'edit_' + data.item.id" class="py-1" v-if="data.item.candidateStatus !== 'Uploaded' && data.item.candidateStatus !== 'UploadedBySourcer' && data.item.candidateStatus !== 'UploadedByRecruiter' && data.item.candidateStatus !== 'AssignedByMassMail' && data.item.candidateStatus !== 'Initiated' && data.item.candidateStatus !== 'Not Interested' && data.item.candidateStatus !== 'Not Answered' && data.item.candidateStatus !== 'Not Relevant' && data.item.candidateStatus !== 'Not Reachable' && data.item.candidateStatus !== 'Call Back' && data.item.candidateStatus !== 'Wrong Number'"
                          @click="updateClick(data.item, jobData.id, data.item.candidateStatus )">
                            <feather-icon icon="EditIcon" variant="outline-primary" />
                          </span> -->
                         
                      
                       </span>
                        
                      </template>

                      <!-- Column: Actions -->
                      <template #cell(actions)="data">
                        <b-dropdown
                          variant="link"
                          no-caret
                          :right="$store.state.appConfig.isRTL"
                          boundary="window"
                          :popper-opts="{ positionFixed: true }"
                          menu-class="jobs-view-actions-dropdown"
                          @show="hoistActionsDropdownMenu"
                          @hidden="restoreActionsDropdownMenu"
                        >
                          <template #button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="align-middle text-body"
                            />
                          </template>
                          

                          <b-dropdown-item 
                            :to="{
                              name: 'apps-candidates-edit',
                              params: { id: data.item.id, jobId: jobData.id },
                              query: { candidateStatus: data.item.candidateStatus },
                            }"
                          >
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Edit Profile</span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="isInActionCandidate(data.item)"
                            @click.prevent="openUpdateResume(data.item)"
                          >
                            <feather-icon icon="UploadIcon" />
                            <span class="align-middle ml-50">Update Resume</span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-else
                            @click.prevent="startResumeUpload(data.item)"
                          >
                            <feather-icon icon="UploadIcon" />
                            <span class="align-middle ml-50">Upload Resume</span>
                          </b-dropdown-item>
                          <!-- <b-dropdown-item v-if="candidateStatus === 'UploadedBySourcer' && candidateStatus === 'Initiated' && candidateStatus === 'UploadedByRecruiter' && candidateStatus === 'AssignedByATSSourcer' && candidateStatus === 'AssignedByMassMail' && candidateStatus === 'Not Interested' && candidateStatus === 'Not Relevant' && candidateStatus === 'Not Answered' && candidateStatus === 'Not Reachable' && candidateStatus === 'Not Answered' && candidateStatus === 'Call Back' && candidateStatus === 'Wrong Number'"
                            @click="shareJD(jobData.attachments)"
                          >
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Share JD</span>
                          </b-dropdown-item> -->
                          <!-- <b-dropdown-item
                            @click="showRemoveCandidateModal(data.item.id, jobData.id)"
                          >
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">Remove From this Job</span>
                          </b-dropdown-item> -->
                          <!--<b-dropdown-item @click="showCModal(data.item.id)">
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Update Status</span>
                          </b-dropdown-item>-->
                        </b-dropdown>
                          </template><!-- Your existing table templates -->
                    </b-table>
                    
                        <!-- Pagination for regular view -->
                        <div class="mx-2">
                          <b-row>
                            <b-col cols="12">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="center"
                      size="sm"
                      class="my-0 mb-2"
                      @change="onPageChange"
                    />
                  </b-col>
                          </b-row>
                        </div>
                      </template>
                    </div>
                  </b-card>
                </div>  
              </b-tab>

              <b-tab title="Job Description" lazy id="job-description">
                <b-row>
                  <b-col cols="12">
                    <job-description-card
                      :job-description="jobData.job_description"
                      :notes="notes"
                      :file="jobData.attachments"
                    />
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Assign Candidates" lazy id="assign-candidates" v-if="$can('read','candidates')">
                <b-row>
                  <b-col cols="12">
                    <candidate-list :job-id="jobData.id" :position-name="jobData.position_name" :client="jobData.client" :attachments="jobData.attachments" :locations="jobData.locations" :acc-mgr="jobData.account_mgr" :all="alltrue" @refreshParent="updateParent"/>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="AI Calling" lazy id="ai-calling" v-if="isAiCallingTabVisible">
                <b-row>
                  <b-col cols="12">
                    <job-ai-calling-tab
                      v-if="aiCallingJobId != null"
                      :job-id="aiCallingJobId"
                      :job-title="jobData.position_name"
                      :client-name="jobData.client"
                      :location="jobData.locations"
                      :role="jobData.role || jobData.position_name"
                      :category="jobData.category"
                      :vertical="jobData.vertical"
                      :domain="jobData.domain"
                      :job-type="jobData.type"
                      :min-exp="jobData.min_exp"
                      :max-exp="jobData.max_exp"
                      :min-ctc="jobData.min_ctc"
                      :max-ctc="jobData.max_ctc"
                      :desired-skills="jobData.desired_skills"
                      :qualification="jobData.qualification"
                      :drive-name="jobData.drive_name"
                      :drive-dates="jobData.drive_dates"
                      :candidates="fetchCandidates || []"
                    />
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Activities" lazy id="activities" v-if="$can('read','job_activity')">
                <b-row>
                  <b-col cols="12">
                    <jobs-view-job-timeline-card :job-timeline="timeline" />
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </div>
          <b-modal
            id="modal-update-status"
            ref="modal-update-status"
            title="Update Status"
            ok-title="submit"
            cancel-variant="outline-secondary"
            @ok="updateStatus"
          >
            <b-form>
              <b-form-group label="Choose the Status" label-for="vue-select">
                <li
                  style="display: inline-flex; margin: 5px; padding: 2px"
                  v-for="status in statusOption"
                  :key="status.text"
                >
                  <b-badge
                    style="color: #5E5873 !important"
                    variant="light"
                    :id="status.text"
                    @click="selectStatus(status.text)"
                    >{{ status.value }}</b-badge
                  >
                </li>
              </b-form-group>
            </b-form>
          </b-modal>
          
          <b-modal
            id="modal-add-notes"
            ref="modal-add-notes"
            title="Add Notes"
            ok-title="submit"
            cancel-variant="outline-secondary"
            @ok="updateNotes"
          >
            <b-form>
              <b-form-group label="Add Notes" label-for="vue-select">
                <b-form-textarea
                  id="textarea-default"
                  v-model="note"
                  placeholder="Add Notes"
                  rows="3"
                />
              </b-form-group>
            </b-form>
          </b-modal>
          <b-modal
            id="modal-remove-candidate"
            ref="modal-remove-candidate"
            title="Reason to remove Candidate"
            ok-title="submit"
            cancel-variant="outline-secondary"
            @ok="removeCandidateFromJob"
          >
            <b-form>
              <b-form-group label="Reason to remove Candidate" label-for="vue-select">
                <b-form-textarea
                  id="textarea-default"
                  v-model="removeCandidateReason"
                  placeholder="Reason"
                  rows="3"
                />
                <small v-if="!removeCandidateReason" class="text-danger"> {{ removeCandError }}</small>
              </b-form-group>
            </b-form>
          </b-modal>
          <!-- <b-modal
        id="modal-cupdate-status"
        ref="modal-cupdate-status"
        title="Update Candidate Status"
        ok-title="submit"
        cancel-variant="outline-secondary"
        @ok="updateCandidateStatus"
      >
        <b-form>
          
          <b-form-group label="Choose the Status" label-for="vue-select">
            <li 
              style="display: inline-flex; margin: 5px; padding: 2px"
              v-for="status in cStatusOption"
              :key="status.text"
            >
              <b-badge
                style="color: black !important"
                variant="light"
                :id="status.text"
                @click="selectCStatus(status.text)"
                >{{ status.value }}</b-badge
              >
            </li>
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Shortlisted'"
            label="Selection Date *"
            label-for="selectedDate"
          >
            <flat-pickr
              class="form-control"
              id="selDate" 
              v-model="selectionDate" 
              placeholder="YYYY-MM-DD"
              :config="flatpickrConfig"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered'"
            label="Offered Date *"
            label-for="offeredDate"
          >
            <flat-pickr
              class="form-control"
              id="offerDate" 
              v-model="offeredDate" 
              placeholder="YYYY-MM-DD"
              :config="flatpickrConfig"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered'"
            label="Joining Date"
            label-for="joiningDate"
          >     
            <flat-pickr
              class="form-control"
              id="joinDate" 
              v-model="joiningDate" 
              placeholder="YYYY-MM-DD"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Offered'"
            label="Offered CTC"
            label-for="offeredCTC"
          >     
            <b-form-input
              class="form-control"
              id="offeredCTC" 
              v-model="offeredCTC" 
              placeholder="Enter CTC in Rupees(complete amount like 10000.00)"
              type="number"
              step=".01"
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Joined'"
            label="Joining Date *"
            label-for="joiningDate"
          >     
            <flat-pickr
              class="form-control"
              id="joinDate" 
              v-model="joiningDate" 
              placeholder="YYYY-MM-DD"
              
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'Early Attrition'"
            label="Attrition Date *"
            label-for="attritionDate"
          >     
            <flat-pickr
              class="form-control"
              id="attritionDate" 
              v-model="attritionDate" 
              placeholder="YYYY-MM-DD"
              
            />
          </b-form-group>
          <b-form-group v-if="statusCSelected === 'NotOffered'"
            label="Drop Reason *"
            label-for="drop-reason"
          >
            <v-select
                      v-model="dropReason"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="notOfferedOptions"
                      ref="drop-reason"
                      :reduce="(option) => option.title"
                    />
                  
          </b-form-group>
          
          <b-form-group v-if="statusCSelected === 'OfferDrop'"
            label="Drop Reason *"
            label-for="drop-reason"
          >
            <v-select
                      v-model="dropReason"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="offerDropOptions"
                      ref="drop-reason"
                      :reduce="(option) => option.title"
                      taggable
                      push-tags
                    />
          </b-form-group> 
          <small v-if="!dropReason && (statusCSelected === 'NotOffered' || statusCSelected === 'OfferDrop')" class="text-danger"> Drop Reason is Mandatory !!</small>
          <small v-if="!statusCSelected" class="text-danger"> {{ error_status }}</small>
          
        </b-form>
      </b-modal> -->
        </b-col>
        <b-col cols="12" xl="12" />
      </b-row>
    </template>
    <!-- Modal to check Candidate Exist in Database Before opening in Naukri -->
    <template>
      
      <b-modal
            id="modal-check-exist-in-db"
            ref="modal-check-exist-in-db"
            title="Check Candidate Exist"
            ok-title="Assign"
            size="xl"
            cancel-variant="outline-secondary"
            @ok="assignJob">
        <b-row>

          <b-col md="12">    
            
            <b-form @submit.prevent>
              <span class="text-danger text-center"> *** NOTE: All Fields are Mandatory !!!</span><br>
              <b-row>
                <b-col md="6">
                    <b-form-group
                    label="First Name"
                    label-for="first-name"
                    >
                        <validation-provider
                            #default="{ errors }"
                            name="First Name"
                            rules="required"
                        >
                            <b-form-input
                                id="first-name"
                                v-model="canExist.firstName"
                                :state="errors.length > 0 ? false:null"
                                placeholder="First Name"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>    
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group
                    label="Last Name"
                    label-for="last-name"
                    >
                        <validation-provider
                            #default="{ errors }"
                            name="Last Name"
                            rules="required"
                        >
                            <b-form-input
                                id="last-name"
                                v-model="canExist.lastName"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Last Name"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>    
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group
                    label="Skill"
                    label-for="skill"
                    >
                        <validation-provider
                            #default="{ errors }"
                            name="Skill"
                            rules="required"
                        >
                            <b-form-input
                                id="skill"
                                v-model="canExist.skill"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Enter Candidate skill"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>    
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group
                    label="Current Company"
                    label-for="current-company"
                    >
                        <validation-provider
                            #default="{ errors }"
                            name="Current Company"
                            rules="required"
                        >
                            <b-form-input
                                id="current-company"
                                v-model="canExist.company"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Enter Candidate Current Company"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>    
                    </b-form-group>
                </b-col>
                <b-col md="12" class="text-center">
                  
                  <b-button variant="outline-primary" @click="checkCandidateExistGetData">Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
          <b-col md="12" class="mt-2" v-if="canExistCandidatesList">
            <span v-if="loading"><b-spinner variant="primary" label="Text Centered"/> Fetching candidates ...</span>
            <b-table
              class="position-relative"
              :items="canExistCandidatesList"
              :fields="canExistCandidatesListFields"
              responsive
              :sort-by.sync="sortBy"
              show-empty
              empty-text="No matching records found"
              :sort-desc.sync="isSortDirDesc"
              select-mode="single"
              selectable
              @row-selected="onRowSelected"
            >
            <!-- <b-table
              class="position-relative"
              :items="canExistCandidatesList"
              :fields="canExistCandidatesListFields"
              responsive
              :sort-by.sync="sortBy"
              show-empty
              empty-text="No matching records found"
              :sort-desc.sync="isSortDirDesc"
              select-mode="single"
              selectable
              @row-selected="onRowSelected"
            > -->
              <template #cell(id)="data">
                <router-link :to="'/apps/candidates/view/' + data.item.id + '/null'" target="_blank" v-if="$can('read','candidates')">
                  {{ data.item.candidate_id}}
                </router-link>
              </template>
              <!-- { key: "id", sortable: true, Label: "ID" },
          { key: "first_name", sortable: true, Label: "Name" },
          { key: "email", sortable: true, Label: "Contact" },
          { key: "curr_company", sortable: true, Label: "Company" },
          { key: "source", sortable: true, Label: "source" },
          { key: "exp", sortable: true, Label: "EXPERIENCE/CTC" },
          { key: "candidateStatus", sortable: true, Label: "STATUS" },
          { key: "job_ids", sortable: true, Label: "JOBS" }, -->
              <template #cell(first_name)="data">
                  {{ data.item.first_name  + ' ' +  data.item.last_name }}
              </template>
              <template #cell(email)="data">
                  <p>{{ data.item.email }} </p>
                  <p>{{ data.item.contact_no }} </p>
              </template>
              <template #cell(curr_company)="data">
                  <p>{{ data.item.curr_company }} </p>
                  <p>{{ data.item.curr_postion }} </p>
              </template>
              <template #cell(source)="data">
                  <p>{{ data.item.source }} </p>
                  <p>{{ data.item.gender }} </p>
              </template>
              <template #cell(exp)="data">
                  {{ data.item.exp }} Years / ₹ {{ data.item.ctc ? data.item.ctc : 0 }} <span v-if="!blueCollar">Lacs</span>
                  
              </template>
              <template #cell(candidateStatus)="data">
                  {{ data.item.candidateStatus }} 
              </template>
              <template #cell(job_ids)="data">
                <!-- {{ data.item.job_ids.split(',') }} -->
                <span v-if="data.item.job_ids">
                  <p v-for="(job,index) in data.item.job_ids.split(',')" :key="index" >
                    <router-link :to="'/apps/view-job/' + job" target="_blank">
                      View Job {{ index + 1 }}
                    </router-link>
                  </p>
                </span>
              </template>

            </b-table>
          </b-col>
        </b-row>
      </b-modal>
    </template>
    <template>
        <b-modal
            id="cv-preview-modal"
            ref="cv-preview-modal"
            ok-only
            ok-title="Accept"
            centered
            size="xl"
            title="CV Preview"
        >
            <div>
                <div v-if="pdf">
                    <iframe :src="blink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
                <div v-if="docx || doc">
                  <a class="text-center font-weight-bolder" :href="mlink" target="_blank" v-if="docx || doc"> Preview CV</a>
                    <iframe :src="mlink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
                <div v-if="rtf">
                    <iframe :src="glink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
                <div v-if="otherDoc">
                    <iframe :src="mlink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
            </div>
        </b-modal>
    </template>

    <!-- Update the modal implementation -->
    <b-modal
      id="modal-custom-date"
      ref="modal-custom-date"
      title="Select Date Range"
      ok-title="Download"
      cancel-variant="outline-secondary"
      @ok="handleCustomDateDownload"
    >
      <b-form>
        <b-form-group
          label="Start Date"
          label-for="start-date"
        >
          <flat-pickr
            id="start-date"
            v-model="customDateRange.startDate"
            class="form-control"
            placeholder="YYYY-MM-DD"
            :config="{ enableTime: false, dateFormat: 'Y-m-d' }"
          />
        </b-form-group>

        <b-form-group
          label="End Date"
          label-for="end-date"
        >
          <flat-pickr
            id="end-date"
            v-model="customDateRange.endDate"
            class="form-control"
            placeholder="YYYY-MM-DD"
            :config="{ enableTime: false, dateFormat: 'Y-m-d' }"
          />
        </b-form-group>
      </b-form>
    </b-modal>
    <div v-if="isDownloading || isCustomDownloading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
    </div>
    <b-modal
      id="modal-schedule-interview"
      ref="modal-schedule-interview"
      title="Schedule Interview"
      ok-title="Schedule"
      cancel-variant="outline-secondary"
      @ok="scheduleInterview"
    >
      <b-form>
        <b-form-group label="Interview Date & Time" label-for="interview-date">
          <flat-pickr
            class="form-control"
            v-model="interviewForm.date"
            :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
            placeholder="Select date and time"
          />
        </b-form-group>
        <b-form-group label="Level" label-for="interview-level">
          <v-select
            v-model="interviewForm.level"
            :options="levelOptions"
            label="title"
            :reduce="(option) => option.title"
            placeholder="Select Level"
          />
        </b-form-group>
        <b-form-group label="Panel Name" label-for="interview-panel">
          <v-select
            v-model="interviewForm.panel"
            :options="panelOptions"
            label="title"
            :reduce="(option) => option.title"
            placeholder="Select Panel"
          />
        </b-form-group>
        <b-form-group label="Round" label-for="interview-round">
          <v-select
            v-model="interviewForm.round"
            :options="roundOptions"
            label="title"
            :reduce="(option) => option.title"
            placeholder="Select Round"
          />
        </b-form-group>
        <b-form-group
          label="Send Interview Reminder To Candidate"
          label-for="interview-reminder"
        >
          <b-form-radio-group
            v-model="interviewReminderSelected"
            :options="interviewReminderOptions"
            class="demo-inline-spacing mb-1"
            value-field="value"
            text-field="text"
            disabled-field="disabled"
          />
          
        </b-form-group>
        <b-form-group
          label="Interview Reminder Timings"
          label-for="interview-reminder-timings"
        >
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="interviewReminderTimingSelected"
            :options="interviewReminderTimingOptions"
            name="flavour-1"
            class="demo-inline-spacing"
          />
          
        </b-form-group>
      </b-form>
    </b-modal>

    <!-- Approval Modal -->
    <b-modal
      id="approval-modal"
      title="Approve Job"
      size="lg"
      :hide-footer="true"
      @hidden="resetApprovalForm"
    >
      <div>
        <b-form>
          <b-form-group label="Review Confirmation" label-for="review-checkbox">
            <b-form-checkbox
              id="review-checkbox"
              v-model="approvalForm.reviewConfirmed"
              name="review-checkbox"
              :value="true"
              :unchecked-value="false"
            >
              I have thoroughly reviewed all job details including position name, client, domain, requirements, 
              compensation, and other specifications. I confirm that all information is accurate and complete.
            </b-form-checkbox>
          </b-form-group>

          <b-form-group label="Comments (Optional)" label-for="approval-comments">
            <b-form-textarea
              id="approval-comments"
              v-model="approvalForm.comments"
              placeholder="Add any comments about the job approval..."
              rows="3"
            />
          </b-form-group>

          <div class="d-flex justify-content-between mt-4">
            <b-button 
              variant="danger" 
              @click="rejectJob"
              :disabled="approvalForm.reviewConfirmed !== true"
            >
              <feather-icon icon="XCircleIcon" size="16" class="mr-1" />
              Reject Job
            </b-button>
            <b-button 
              variant="success" 
              @click="approveJob"
              :disabled="approvalForm.reviewConfirmed !== true"
            >
              <feather-icon icon="CheckCircleIcon" size="16" class="mr-1" />
              Approve Job
            </b-button>
          </div>
        </b-form>
      </div>
    </b-modal>

    <!-- Rejection Modal -->
    <b-modal
      id="rejection-modal"
      title="Reject Job"
      size="md"
      :hide-footer="true"
      @hidden="resetApprovalForm"
    >
      <div>
        <b-form>
          <b-form-group label="Rejection Reason *" label-for="rejection-reason">
            <b-form-textarea
              id="rejection-reason"
              v-model="approvalForm.rejectionReason"
              placeholder="Please provide the reason for rejecting this job..."
              rows="4"
              required
              :state="approvalForm.rejectionReason && approvalForm.rejectionReason.trim() !== ''"
            />
            <small v-if="(!approvalForm.rejectionReason || approvalForm.rejectionReason.trim() === '') && showRejectionError" class="text-danger">
              Rejection reason is required
            </small>
          </b-form-group>

          <div class="d-flex justify-content-end mt-4">
            <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('rejection-modal')">
              Cancel
            </b-button>
            <b-button 
              variant="danger" 
              @click="confirmRejectJob"
              :disabled="!approvalForm.rejectionReason || approvalForm.rejectionReason.trim() === ''"
            >
              <feather-icon icon="XCircleIcon" size="16" class="mr-1" />
              Confirm Rejection
            </b-button>
          </div>
        </b-form>
      </div>
    </b-modal>

    <!-- Outbound Dialer Modal -->
    <outbound-call-modal
      ref="outboundDialer"
      :job-id="id"
      :job-name="jobData && jobData.position_name"
      :job-category="jobData && jobData.category"
      :job-vertical="jobData && jobData.vertical"
      @refresh="getJobData"
      @switch-to-assign="switchToAssignCandidatesTab"
    />
    <input
      ref="resumeFileInput"
      type="file"
      class="d-none"
      :accept="resumeAccept"
      @change="onResumeFileSelected"
    >
    <update-resume-modal
      :visible.sync="resumeModalVisible"
      :candidate="resumeUploadCandidate"
      :uploading="resumeUploading"
      @submit="submitResumeUpdate"
    />
  </div>
</template>
<script>
import {
  BCard,
  BButton,
  BAvatarGroup,
  BAvatar,
  BRow,
  BCol,
  BTabs,
  BTab,
  VBTooltip,
  BCardBody,
  BCardText,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormTextarea,
  BCardHeader,
  BSidebar,
  BBadge,
  BListGroup,
  BListGroupItem,
  BFormInput,
  BTable,
  BPagination,
  BMedia,
  BLink,
  BSpinner, //BButton, BSidebar, VBToggle
  BFormCheckboxGroup,
  BFormRadioGroup,
  BModal,
  BFormCheckbox
} from "bootstrap-vue";
//import {BButton, BSidebar, VBToggle} from 'bootstrap-vue'
//import Ripple from 'vue-ripple-directive'
//import JobsViewJobInfoCard from './JobsViewJobInfoCard.vue'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { avatarText } from "@core/utils/filter";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CandidateList from "@/views/apps/candidate/candidates-list/CandidateList.vue";
import JobDescriptionCard from "./JobDescriptionCard.vue";
import JobsViewJobTimelineCard from "./JobsViewJobTimelineCard.vue";
import JobService from "@/services/job-service";
import NoteService from "@/services/note-service";
import flatPickr from 'vue-flatpickr-component'
//import CandidateService from "@/services/candidate-service";
import CandidateListAddNew from "@/views/apps/candidate/candidates-list/CandidateListAddNew.vue";
//import CandidateListAddNewOld from "@/views/apps/candidate/candidates-list/CandidateListAddNew_OLD.vue";
import moment from "moment";
import jobTimelineService from '@/services/job-timeline'
import candidateService from "@/services/candidate-service";
import emailTemplates from "@/services/email-templates";
import mailService from "@/services/mail-service"
import UserService from "@/services/user-service"
import interviewService from "@/services/interview-service";
import elasticSearchService from "@/services/elastic-search-service"
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { required,double } from '@validations'
import jobService from '../../../../services/job-service';

import Excel from 'exceljs';
import { saveAs } from 'file-saver';
// import Vue from 'vue';
// // Import Vuex store if it's not in the same file
// import store from '@/store';
// // import { abilitiesPlugin } from '@casl/vue';
// // Vue.use(abilitiesPlugin, store.state.ability);

// Add to imports at the top
import AdminConfigService from '@/services/admin-config-service'
import OutboundCallModal from '@/views/apps/calls/OutboundCallModal.vue'
import { allowedNextStatusOptions } from '@/utils/candidate-status-flow'
import JobAiCallingTab from '@/views/apps/jobs/jobs-view/JobAiCallingTab.vue'
import { canViewAiCalling } from '@/utils/ai-calling-permissions'
import {
  loadAgentAvailability,
  onAvailabilityChange,
} from '@/utils/exotel-agent-availability'
import { parseAddedByTitle } from '../job-list-helpers'
import { length } from "vee-validate/dist/rules";
import uploadResumeMixin from '@/mixins/uploadResumeMixin'
import UpdateResumeModal from '@/views/apps/candidate/components/UpdateResumeModal.vue'

export default {
  mixins: [uploadResumeMixin],
  components: {
    UpdateResumeModal,
    BRow,
    BCol,
    //BAlert,
    //JobsViewJobInfoCard,
    BCard,
    BButton,
    BAvatarGroup,
    BAvatar,
    BTabs,
    BTab,
    JobDescriptionCard,
    JobsViewJobTimelineCard,
    CandidateList,
    JobAiCallingTab,
    BCardBody,
    BDropdown,
    BDropdownItem,
    BForm,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    vSelect,
    BCardHeader,
    BSidebar,
    BBadge,
    BListGroup,
    BListGroupItem,
    BCardText,
    BTable,
    BPagination,
    CandidateListAddNew,
    //CandidateListAddNewOld,
    BMedia,
    BLink,
    flatPickr,
    AppCollapse,
    AppCollapseItem,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BFormCheckboxGroup,
    BFormRadioGroup,
    BModal,
    BFormCheckbox,
    OutboundCallModal,
    // abilitiesPlugin
    
    //BButton,
    //BSidebar,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      activeTabIndex: 0,
      aiCallingTabRevealed: false,
      aiCallingSpecialUsers: [],
      hasDialerAccess: false,
      exotelConfig: null,
      callsAvailable: true,
      _availabilityUnsub: null,
      id: "",
      jobData: null,
      jobHeaderLoading: true,
      candidatesLoading: true,
      jobLoadError: null,
      notesData: [],
      jobDescription: "",
      file: "",
      pageLength: 3,
      dir: false,
      statusSelected: "",
      statusCSelected: "",
      job_id: "",
      statusOption: [
        { value: "Active", text: "Active" },
        { value: "On Hold", text: "OnHold" },
        { value: "Draft", text: "Draft" },
        { value: "Closed", text: "Closed" },
        { value: "Cancelled", text: "Cancelled" },
        { value: "Target Date Breached", text: "TargetDateBreached" },
      ],
      
      cStatusOption: [
        // { value: "Screen Reject", title: "ScreenReject" },
        // { value: "Screen Select", title: "ScreenSelect" },
        // { value: "Duplicate", title: "Duplicate" },
        // { value: "Inprocess", title: "Inprocess" },
        // { value: "OnHold", title: "OnHold" },
        // { value: "Shortlisted", title: "Shortlisted" },
        // { value: "Offered", title: "Offered" },
        // { value: "Not Offered", title: "NotOffered" },
        // { value: "Joined", title: "Joined" },
        // { value: "Offer Drop", title: "OfferDrop" },
        // { value: "Rejected", title: "Rejected" },
      ],
      fetchCandidates: [],
      fetchCandidatesBKP: [],
      todaysCandidates: [],
      tableColumns: [
        { key: "id", sortable: true, Label: "Title" },
        //{ key: 'first_name', sortable: true },
        { key: "email", sortable: true, label: "Contact" },
        //{ key: 'contact_no', label: 'Contact', sortable: true },
        {
          key: "curr_location",
          label: "Location",
          formatter: true,
          sortable: true,
        },
        {
          key: "sourcer_name",
          label: "Sourcer / Recruiter",
          sortable: true,
        },
        { key: "status", sortable: true },
        { key: "actions" },
      ],
      VerifyProfileColumns: [
        { key: "id", sortable: true, Label: "Title" },
        //{ key: 'first_name', sortable: true },
        { key: "email", sortable: true, label: "Contact" },
        //{ key: 'contact_no', label: 'Contact', sortable: true },
        
        { key: "status", sortable: true , label: "Status"},
        { key: "extra_details", sortable: true , label: "Business/Level"},
        // { key: "extra_details.verifierScore", sortable: true , label: "Score"},
        { key: "actions" },
        
      ],
      note: "",
      totalCandidates: 0,
      initiatedC: {},
      approvedC: {},
      pageNumber: null,
      inprocessC: {},
      shortlistedC: {},
      offeredC: {},
      joinedC: {},
      screenSelectC: {},
      onholdC: {},
      reviewrejectC: {},
      // Approval form data
      approvalForm: {
        reviewConfirmed: false,
        comments: '',
        rejectionReason: ''
      },
      showRejectionError: false,
      totalRows: 0,
      screenrejectC: {},
      duplicateC: {},
      notofferedC: {},
      offerdropC: {},
      rejectedC: {},
      notrelevantC: {},
      notinterestedC: {},

      rows: [],
      searchTerm: "",
      avatarText,
      selected: "Active",
      option: [
        "Active",
        "OnHold",
        "Draft",
        "Closed",
        "Cancelled",
        "TargetDateBreached",
      ],
      alltrue: "true",
      allfalse: "false",
      perPage: parseInt(this.$route.query.size) || 25,
      // totalRows: 0,
      totalCandidates: 0,
      currentPage: parseInt(this.$route.query.page) || 1,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      sortDesc: true,
        sortDirection: 'desc',
      from: 0,
      to: 0,
      of: 0,
      isAddNewCandidateSidebarActive: false,
      filter: "",
      noticePeriod: [{title: "Immediate", value: 0}, {title: "0-15", value: 15}, {title: "15-30", value: 30},{title: "30-45", value: 45},{title: "45-60", value: 60}, {title: "60-90", value: 90}],
      removeCandidateReason: '',
      can_id: '',
      removeCandError: '',
      canLoadingDone: false,
      timeline: '',
      notes: '',
      isRecruiter: '',
      isSourcer: '',
      isAccountManager: '',
      isAdminMaster: '',
      // updateClicked: false,
      allUsers: '',
      joiningDate: '',
      offeredDate: '',
      selectionDate: '',
      attritionDate: '',
      isValid: true,
      candidate: {},
      candidateId: '',
      jobId: '',
      prevStatus: '',
      error_status: '',
      offeredCTC: '',
      dropReason: '',
      notOfferedOptions: [
        {title: 'CTC Issue'},
        {title: 'Notice Period Issue'},
        {title: 'Location Issue'},
        {title: 'Designation Issue'},
        {title: 'Position Closed'},
        {title: 'Position On-Hold'}
      ],
      offerDropOptions: [
        {title: 'Got Another Offer'},
        {title: 'Retained By Current Organization'},
        {title: 'CTC Issue'},
        {title: 'Notice Period Issue'},
        {title: 'Location Issue'},
        {title: 'Designation Issue'},
        {title: 'BGV/Documentation Issue'},
      ],
      flatpickrConfig: {
        maxDate: "today"
      },
      numberOfPages : [],
      newPage: true,
      canExist: {
        firstName: null,
        lastName: null,
        skill: null,
        company: null
      },
      canExistCandidatesList: null,
      canExistCandidatesListFields : [
        { key: "id", sortable: true, label: "ID" },
        { key: "first_name", sortable: true, label: "Name" },
        { key: "email", sortable: true, label: "Contact" },
        { key: "skills", sortable: true, label: "Job Name" },
        { key: "curr_company", sortable: true, label: "Company" },
        { key: "source", sortable: true, label: "source" },
        { key: "exp", sortable: true, label: "EXPERIENCE/CTC" },
        { key: "candidateStatus", sortable: true, label: "STATUS" },
        { key: "job_ids", sortable: true, label: "JOBS" },
      ],
      //variables for doc preview
      blink: null,
      glink: null,
      pdf: false,
      docx: false,
      rtf: false,
      doc: false,
      otherDoc: false,
      mlink: null,
      dlink: null,
      selectedCandidates: [],
      empId: null,
      verifierName: null,
      filterType: null,
      resetPoolPageOnRefresh: false,
      scrollRestoreTimer: null,
      loading: false,
      blueCollar: false,
      currentTime: null,
      // searchFilters: {
      //   page : 1
      // }
      //jData: this.jobData
      customDateRange: {
        startDate: '',
        endDate: ''
      },
      isDownloading: false,
      isCustomDownloading: false,
      activeTab: 0,
      businessOptions: [],
      levelOptions: [],
      
      interviewForm: {
        date: null,
        level: null,
        panel: null,
        round: null,
      },
      panelOptions: [],
      roundOptions: [],
      candidate_id: null,
      verifierList: [
        { emp_id: 'SH-026' },
        { emp_id: 'SH-055' },
        { emp_id: 'SH-024' },
        { emp_id: 'SH-040' },
        { emp_id: 'SH-094' },
        { emp_id: 'SH-002' },
        { emp_id: 'SH-003' },
        { emp_id: 'SH-001' },
      ],
      interviewReminderSelected: true,
      interviewReminderOptions: [
        { text: 'Yes', value: true },
        { text: 'No', value: false }
      ],
      interviewReminderTimingOptions: [
        { text: '30 minutes before', value: '30m' },        
        { text: 'Interview Day Morning', value: 'M' },
        { text: '1 day Before', value: '1d' },
      ],
      interviewReminderTimingSelected: ['30m', 'M', '1d'],
    };
  },
  watch: {
    // '$route'(to, from) {
    //   // console.log('to: ', to)
    //   // console.log('from: ', from)
    //   if (to.query.page !== from.query.page) {
    //     this.newPage = false
    //   }
    // }
    // currentPage: {
    //   this.searchFilters.page = currentPage
    // },
    // When currentPage changes, update the route if different from current route
    // currentPage: {
    //     handler(newFilters) {
    //       // Convert query parameters and new filters to strings for easy comparison
    //       const currentQuery = JSON.stringify(this.$route.query);
    //       const newQuery = JSON.stringify(newFilters);

    //       // Only navigate if the queries are different
    //       if (currentQuery !== newQuery) {
    //         this.$router.push({ query: { page: currentPage} }).catch(err => {
    //           if (err.name !== 'NavigationDuplicated') {
    //             throw err;
    //           }
    //           // Ignore NavigationDuplicated error, but rethrow all other errors
    //         });
    //       }
    //     },
    //     deep: true,
    //   },
    //   $route(to) {
    //     this.currentPage = { ...this.currentPage, ...to.query };
    //   },
    jobData: {
      handler(newVal, oldVal) {
        const newId = newVal && newVal.id
        const oldId = oldVal && oldVal.id
        if (oldId != null && oldId !== '' && newId != null && String(newId) !== String(oldId)) {
          this.resetAiCallingTabReveal()
        }
        if (newId) {
          this.fetchKPMGDropDownOptions()
        }
      },
      immediate: true
    },
    '$route.params.id'(newId, oldId) {
      if (newId == null || newId === '' || String(newId) === String(oldId)) return
      this.id = newId
      this.resetAiCallingTabReveal()
      this.applyAiCallingDeepLink()
      this.getJobData()
    },
    '$route.query.tab'() {
      this.applyAiCallingDeepLink()
    },
    '$route.hash'() {
      this.applyAiCallingDeepLink()
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.applyAiCallingDeepLink()
    // Check if current user has Exotel DID — show Dialer button only if they do
    AdminConfigService.getExotelConfig().then(res => {
      if (res && res.status === 'OK' && Array.isArray(res.data)) {
        this.exotelConfig = res.data
        const userData = JSON.parse(localStorage.getItem('userData') || '{}')
        const empId = userData && userData.emp_id
        this.hasDialerAccess = res.data.some(c => String(c.emp_id) === String(empId))
      }
    }).catch(() => {})

    loadAgentAvailability({ force: true }).then(row => {
      this.callsAvailable = row ? row.calls_available !== false : true
    }).catch(() => {})

    this._availabilityUnsub = onAvailabilityChange(detail => {
      this.callsAvailable = detail.calls_available !== false
    })

    AdminConfigService.getAiCallingConfig().then(res => {
      if (res && (res.status === 'OK' || res.data)) {
        const data = res.data && typeof res.data === 'object' && !Array.isArray(res.data)
          ? res.data
          : res
        this.aiCallingSpecialUsers = Array.isArray(data.specialUsers) ? data.specialUsers : []
        if (this.aiCallingTabRevealed) {
          this.$nextTick(() => this.selectAiCallingTab())
        }
      }
    }).catch(() => {})
    
    localStorage.setItem('pageSize', this.perPage);
    // if(this.$route.query) { 
    //   this.currentPage = this.$route.query.page ? this.$route.query.page : ''
    // } else {
    //   this.$router.push({ query: { page: this.currentPage }});
    // }
    // console.log('route queries', this.$route)
    // if(!this.$route.query.page) {
    //   console.log('in no route query')
    //   this.$router.push({ query: { page: this.currentPage, size: this.perPage }});
    //   //this.searchFilters.page = this.currentPage
    // }
    // if(this.$route.query) {
    //   this.$router.push({ query: { page: this.$route.query.page, size: this.perPage }});
    //   //this.searchFilters.page = this.$route.query.page
    //   this.currentPage = this.$route.query.page
    //   this.perPage = this.$route.query.size
    //   //this.searchFilters.page = this.$route.query.page
    // } 
    const userD = JSON.parse(localStorage.getItem('userData'))
    this.empId = userD.emp_id
    this.verifierName = userD.first_name + ' ' + userD.last_name
    
    //this.setCurrentPageFromRoute();
    //currentPage: parseInt(this.$route.query.page) || 1,
    ////console.log(this.id);

    this.getJobData();
    
    // Check if job is pending approval and redirect if user doesn't have approval permissions
    // this.checkApprovalAccess();
    
    // const localItemsCount = this.fetchCandidates
    //   ? this.fetchCandidates.length
    //   : 0;
    // this.from =
    //   this.perPage.value * (this.currentPage.value - 1) +
    //   (localItemsCount ? 1 : 0);
    // this.to =
    //   this.perPage.value * (this.currentPage.value - 1) + localItemsCount;
    // this.of = this.fetchCandidates.length;

    // UserService.getAllUsersDd().then(res => {
    //   this.allUsers = res.data
    //   //console.log('recruiters',this.allUsers)
    // })
    UserService.getAllUsersDdActiveInactive().then(res => {
      this.allUsers = res.data
      if (Array.isArray(this.fetchCandidatesBKP) && this.fetchCandidatesBKP.length) {
        this.fetchCandidatesBKP = this.fetchCandidatesBKP.map(row => this.slimJobPoolCandidate(row))
        this.filterCandidate(this.filterType || 'all')
      }
    })
    if (this.jobData && this.jobData.id) {
      this.fetchKPMGDropDownOptions()
    }
  },
  computed: {
    // fetchCandidates() {
    //   return this.filter
    //     ? this.fetchCandidates.filter(
    //         (item) =>
    //           item.first_name.includes(this.filter) ||
    //           item.last_name.includes(this.filter) ||
    //           item.email.includes(this.filter) ||
    //           item.contact_no.includes(this.filter) ||
    //           item.curr_location.includes(this.filter) ||
    //           item.source.includes(this.filter) ||
    //           item.status.includes(this.filter) ||
    //           item.candidate_id.includes(this.filter)
    //           //item.curr_company.includes(this.filter)
    //       )
    //     : this.fetchCandidates;
    // },
    // ifPermitted() {
    //   const userD = JSON.parse(localStorage.getItem('userData'))
    //   const role = userD.roles[0]
    //   let permit = false
    //   if(role === 'ACCOUNT-MANAGER' || role === 'ADMIN' || role === 'MASTER' || this.empId === 'SH-038'){
    //     permit = true
    //   } else {
    //     permit = false
    //   }
    //   return permit;
    // },
    // ifHRMIS() {
    //   const userD = JSON.parse(localStorage.getItem('userData'))
    //   const role = userD.roles[0]
    //   let permit = false
    //   if( role === 'HR' || role === 'MIS' ){
    //     permit = false
    //   } else {
    //     permit = true
    //   }
    //   return permit;
    // },
    updateShow() {

    },
    businessTabs() {
      // Get unique business values from jobData.business
      if (!this.jobData || !this.jobData.business) return [];
      
      return this.jobData.business
        .split(',')
        .map(b => b.trim())
        .filter(b => b); // Remove empty values
    },

    // Get candidates for current active tab
    currentTabCandidates() {
      if (this.activeTab === 0) return this.fetchCandidates;
      
      const business = this.businessTabs[this.activeTab - 1];
      return this.getBusinessCandidates(business);
    },
    isKPMGRPO() {
      return this.jobData?.client === 'KPMG RPO';
    },
    canMakeCall() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const empId = userData && userData.emp_id
      const hasExotelPermission = this.exotelConfig && Array.isArray(this.exotelConfig)
        ? this.exotelConfig.some(c => String(c.emp_id) === String(empId))
        : false
      const hasCreatePermission = this.$can ? this.$can('create', 'exotel_call') : false
      return (hasExotelPermission || hasCreatePermission) && this.callsAvailable !== false
    },
    showAiCallingTab() {
      return canViewAiCalling(this.$can.bind(this), this.aiCallingSpecialUsers)
    },
    isAiCallingTabVisible() {
      return this.showAiCallingTab && this.aiCallingTabRevealed
    },
    // Prefer loaded job.id; fall back to route param so the tab never mounts with undefined.
    aiCallingJobId() {
      const fromJob = this.jobData && this.jobData.id
      if (fromJob != null && fromJob !== '') return fromJob
      const fromRoute = this.id
      if (fromRoute != null && fromRoute !== '') return fromRoute
      return null
    },
    jobTabIds() {
      const ids = ['job-details', 'job-description']
      if (this.$can('read', 'candidates')) ids.push('assign-candidates')
      if (this.isAiCallingTabVisible) ids.push('ai-calling')
      if (this.$can('read', 'job_activity')) ids.push('activities')
      return ids
    },
    filteredCandidates() {
      if (!this.fetchCandidates) return [];
      
      // If there's a search filter, apply it across all candidates
      if (this.filter) {
        return this.fetchCandidates.filter(candidate => {
          const searchTerm = this.filter.toLowerCase();
          return (
            (candidate.first_name && candidate.first_name.toLowerCase().includes(searchTerm)) ||
            (candidate.last_name && candidate.last_name.toLowerCase().includes(searchTerm)) ||
            (candidate.email && candidate.email.toLowerCase().includes(searchTerm)) ||
            (candidate.status && candidate.status.toLowerCase().includes(searchTerm))
          );
        });
      }

      // Return all candidates if no filter
      return this.fetchCandidates;
    },

    // Status-specific computed properties
    initiatedCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'Initiated');
    },
    inprocessCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'Inprocess');
    },
    shortlistedCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'Shortlisted');
    },
    offeredCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'Offered');
    },
    joinedCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'Joined');
    },
    screenSelectCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'ScreenSelect');
    },
    onholdCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'OnHold');
    },
    reviewrejectCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'ReviewReject');
    },
    screenrejectCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'ScreenReject');
    },
    duplicateCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'Duplicate');
    },
    notofferedCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'NotOffered');
    },
    offerdropCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'OfferDrop');
    },
    rejectedCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'Rejected');
    },
    notrelevantCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'NotRelevant');
    },
    notinterestedCandidates() {
      return this.filteredCandidates.filter(c => c.status === 'NotInterested');
    },
    candidateStatusSummary() {
      // Aggregate counts by candidateStatus
      const summary = {};
      (this.fetchCandidates || []).forEach(candidate => {
        const status = candidate.candidateStatus || 'Unknown';
        summary[status] = (summary[status] || 0) + 1;
      });
      return summary;
    },
    jobLoadErrorTitle() {
      if (this.jobLoadError === 'missing') return 'Job not found'
      if (this.jobLoadError === 'forbidden') return 'You are not authorized to view this job'
      if (this.jobLoadError === 'not_found') return 'Job not found'
      return 'Unable to load job details'
    },
    jobLoadErrorMessage() {
      if (this.jobLoadError === 'missing') return 'The job id is missing or invalid. Open this page from the jobs list.'
      if (this.jobLoadError === 'forbidden') return 'You do not have permission to view this job.'
      if (this.jobLoadError === 'not_found') return 'This job does not exist or is no longer available.'
      return 'The job request failed. Try again from the jobs list.'
    },
  },
  methods: {
    parseAddedByTitle,
    // b-dropdown has no container="body"; .content { backface-visibility } keeps
    // the menu under Vuexy customizer FABs (z-index 1051). Hoist to <body> on show.
    hoistActionsDropdownMenu(bvEvt) {
      const menu = bvEvt && bvEvt.target
      if (!menu || !menu.parentNode || menu.parentNode === document.body) return
      document.body.appendChild(menu)
    },
    restoreActionsDropdownMenu(bvEvt) {
      const menu = bvEvt && bvEvt.target
      const dropdownEl = bvEvt && bvEvt.vueTarget && bvEvt.vueTarget.$el
      if (!menu || !dropdownEl || dropdownEl.contains(menu)) return
      dropdownEl.appendChild(menu)
    },
    openOutboundDialer(phone) {
      if (this.$refs.outboundDialer && typeof this.$refs.outboundDialer.openWithPhone === 'function') {
        this.$refs.outboundDialer.openWithPhone(phone)
      }
      this.$bvModal.show('modal-outbound-dialer')
    },
    routeTargetsAiCallingTab() {
      const query = (this.$route && this.$route.query) || {}
      const tab = String(query.tab || query.activeTab || '').toLowerCase()
      const hash = String((this.$route && this.$route.hash) || '').toLowerCase()
      return tab === 'ai-calling' || hash === '#ai-calling'
    },
    applyAiCallingDeepLink() {
      if (!this.routeTargetsAiCallingTab()) return
      this.aiCallingTabRevealed = true
      this.$nextTick(() => this.selectAiCallingTab())
    },
    resetAiCallingTabReveal() {
      const currentId = this.jobTabIds[this.activeTabIndex]
      this.aiCallingTabRevealed = false
      if (!currentId || currentId === 'ai-calling') {
        this.activeTabIndex = 0
        return
      }
      const next = this.jobTabIds.indexOf(currentId)
      this.activeTabIndex = next >= 0 ? next : 0
    },
    selectAiCallingTab() {
      const index = this.jobTabIds.indexOf('ai-calling')
      if (index >= 0) this.activeTabIndex = index
    },
    openAiCallingTab() {
      this.aiCallingTabRevealed = true
      this.$nextTick(() => this.selectAiCallingTab())
    },
    switchToAssignCandidatesTab() {
      const index = this.jobTabIds.indexOf('assign-candidates')
      this.activeTabIndex = index >= 0 ? index : 0
    },

    isLoggedIn() {
      const expireIn = localStorage.getItem('expireIn')
      if (Math.floor(Date.now() / 1000) > expireIn) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
          //console.log("called logout")
          localStorage.clear();
          this.$router.push({ name: "auth-login" });
      }
    },
    openAddJobSourcerPage() {
      this.isLoggedIn()
      
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right-sourcer')
      // this.currentTime = new Date().getTime()
    },
    openAddJobPage() {
      this.isLoggedIn()
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    
    isSessionAuthFailure(res) {
      if (!res) return false
      if (res.status === 401) return true
      const msg = res.data && res.data.error && res.data.error.message
      return msg === 'jwt expired'
    },
    forceLogout() {
      window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
      localStorage.clear()
      this.$router.push({ name: 'auth-login' })
    },
    classifyJobHttpError(res) {
      const status = res && res.status
      if (status === 404) return 'not_found'
      if (status === 403) return 'forbidden'
      return 'failed'
    },
    extractJobRecord(res) {
      if (!res || typeof res.status === 'number') return null
      const body = (res.status === 'OK' || res.status === 200) && res.data !== undefined ? res.data : res
      if (!body) return null
      if (Array.isArray(body.job) && body.job[0]) return body.job[0]
      if (body.job && typeof body.job === 'object' && !Array.isArray(body.job)) return body.job
      if (Array.isArray(body) && body[0] && (body[0].id || body[0].job_id || body[0].position_name)) return body[0]
      if (body.id || body.job_id || body.position_name) return body
      if (body.data && typeof body.data === 'object' && !Array.isArray(body.data)) {
        const nested = body.data
        if (Array.isArray(nested.job) && nested.job[0]) return nested.job[0]
        if (nested.id || nested.job_id || nested.position_name) return nested
      }
      return null
    },
    extractCandidateList(res) {
      if (!res || typeof res.status === 'number') return null
      if (res.status === 'OK' || res.status === 200) {
        if (Array.isArray(res.data)) return res.data
        if (res.data && Array.isArray(res.data.candidates)) return res.data.candidates
      }
      if (Array.isArray(res.candidates)) return res.candidates
      if (Array.isArray(res.data)) return res.data
      return null
    },
    isJobLifecycleStatus(value) {
      const key = String(value || '').toLowerCase().replace(/\s+/g, '')
      return ['active', 'closed', 'approvalpending', 'draft', 'inactive', 'open'].includes(key)
    },
    isIntakePoolStatus(value) {
      const key = String(value || '').toLowerCase().replace(/\s+/g, '')
      return [
        'uploaded',
        'uploadedbysourcer',
        'uploadedbyrecruiter',
        'assignedbymassmail',
        'assignedbyatssourcer',
        'initiated',
      ].includes(key)
    },
    sanitizePoolStatus(value) {
      if (value == null || value === '') return ''
      if (typeof value === 'object') {
        const nested = value.candidateStatus || value.candidate_status || value.current_status || value.currentStatus
        return this.sanitizePoolStatus(nested)
      }
      const text = String(value).trim()
      if (!text || this.isJobLifecycleStatus(text)) return ''
      return text
    },
    pickAssignmentStatus(obj, allowGenericStatus) {
      if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return ''
      const keys = ['candidateStatus', 'candidate_status', 'current_status', 'currentStatus']
      for (let i = 0; i < keys.length; i++) {
        const picked = this.sanitizePoolStatus(obj[keys[i]])
        if (picked) return picked
      }
      const jobStatus = this.sanitizePoolStatus(obj.job_status || obj.jobStatus)
      if (jobStatus) return jobStatus
      if (allowGenericStatus) return this.sanitizePoolStatus(obj.status)
      return ''
    },
    matchesPoolJob(obj) {
      if (!obj || typeof obj !== 'object') return false
      const jobPk = this.jobData && this.jobData.id != null ? this.jobData.id : this.id
      const jobCode = this.jobData && this.jobData.job_id
      const ids = [obj.id, obj.job_id, obj.jobId, obj.job_pk]
      const nested = obj.candidate_jobs && typeof obj.candidate_jobs === 'object' && !Array.isArray(obj.candidate_jobs)
        ? obj.candidate_jobs
        : null
      if (nested) ids.push(nested.job_id, nested.jobId, nested.id)
      return ids.some(value => {
        if (value == null || value === '') return false
        if (jobPk != null && String(value) === String(jobPk)) return true
        if (jobCode && String(value) === String(jobCode)) return true
        return false
      })
    },
    unwrapPoolAssignment(obj) {
      if (!obj || typeof obj !== 'object') return null
      const nested = obj.candidate_jobs || obj.candidateJobs
      if (nested && typeof nested === 'object' && !Array.isArray(nested)) return nested
      return obj
    },
    findPoolAssignment(row) {
      if (!row || typeof row !== 'object') return null
      const through = this.parseJobJsonField(row.candidate_jobs || row.CandidateJob)
      if (through && typeof through === 'object' && !Array.isArray(through)) return through
      if (Array.isArray(through) && through.length) {
        const match = through.find(item => this.matchesPoolJob(item)) || (through.length === 1 ? through[0] : null)
        return this.unwrapPoolAssignment(match)
      }
      const lists = [row.jobs, row.candidateJobs, row.Jobs]
      for (let i = 0; i < lists.length; i++) {
        const parsed = this.parseJobJsonField(lists[i])
        if (!Array.isArray(parsed) || !parsed.length) continue
        const match = parsed.find(item => this.matchesPoolJob(item)) || (parsed.length === 1 ? parsed[0] : null)
        if (!match) continue
        return this.unwrapPoolAssignment(match)
      }
      return null
    },
    pickLatestTimelineStatus(row) {
      const list = this.parseJobJsonField(row && (row.timeline || row.timelines || row.events || row.job_timeline))
      if (!Array.isArray(list) || !list.length) return ''
      const dated = list.slice().sort((a, b) => {
        const ta = new Date((a && (a.createdAt || a.created_at || a.updatedAt || a.updated_at)) || 0).getTime()
        const tb = new Date((b && (b.createdAt || b.created_at || b.updatedAt || b.updated_at)) || 0).getTime()
        return tb - ta
      })
      for (let i = 0; i < dated.length; i++) {
        const event = dated[i]
        const own = this.pickAssignmentStatus(event, false)
          || this.pickAssignmentStatus(event && event.candidate_jobs, true)
        if (own) return own
        const title = String((event && event.title) || '')
        const match = title.match(/status changes? to (.+)$/i)
        if (match) {
          const fromTitle = this.sanitizePoolStatus(match[1])
          if (fromTitle) return fromTitle
        }
      }
      return ''
    },
    resolveJobPoolCandidateStatus(row) {
      if (!row || typeof row !== 'object') return ''
      const extra = this.parseJobJsonField(row.extra_details || row.extraDetails)
      const assignment = this.findPoolAssignment(row)
      const assignmentStatus = this.pickAssignmentStatus(assignment, true)
        || this.pickAssignmentStatus(row.job_assignment || row.assignment, true)
      const extraStatus = this.pickAssignmentStatus(extra && typeof extra === 'object' && !Array.isArray(extra) ? extra : null, false)
      const timelineStatus = this.pickLatestTimelineStatus(row)
      const topStatus = this.pickAssignmentStatus(row, false)
      const globalStatus = this.sanitizePoolStatus(row.status)
      const ranked = [assignmentStatus, extraStatus, timelineStatus, topStatus, globalStatus].filter(Boolean)
      const current = ranked.find(status => !this.isIntakePoolStatus(status))
      return current || ranked[0] || ''
    },
    avatarCountText(count) {
      if (count == null || count === '') return '0'
      return String(count)
    },
    poolRoleAvatarText(letter) {
      return String(letter == null ? '' : letter)
    },
    sanitizePoolText(value) {
      if (value === undefined || value === null) return ''
      const text = String(value).trim()
      if (!text || /^undefined$/i.test(text) || /^null$/i.test(text) || text === 'NaN') return ''
      return text
    },
    poolDisplayName(value) {
      return this.sanitizePoolText(value) || '—'
    },
    isPoolRoleLabel(text) {
      const key = String(text || '').toLowerCase().replace(/\s+/g, '')
      return key === 'sourcer' || key === 'recruiter'
    },
    looksLikeEmpId(text) {
      return /^[A-Z]{1,6}[-_]?\d+$/i.test(String(text || '').trim())
    },
    displayPoolPersonName(value) {
      if (value == null || value === '') return ''
      const parsed = this.parseJobJsonField(value)
      if (Array.isArray(parsed)) {
        for (let i = 0; i < parsed.length; i++) {
          const name = this.displayPoolPersonName(parsed[i])
          if (name) return name
        }
        return ''
      }
      if (parsed && typeof parsed === 'object') {
        const name = this.sanitizePoolText(parsed.title || parsed.name || parsed.full_name || parsed.fullName)
        if (name && !this.isPoolRoleLabel(name) && !this.looksLikeEmpId(name)) return name
        return ''
      }
      const fromAddedBy = parseAddedByTitle(parsed)
      if (fromAddedBy && !this.isPoolRoleLabel(fromAddedBy) && !this.looksLikeEmpId(fromAddedBy)) {
        return this.sanitizePoolText(fromAddedBy)
      }
      const text = this.sanitizePoolText(parsed)
      if (!text || this.isPoolRoleLabel(text) || this.looksLikeEmpId(text)) return ''
      return text
    },
    extractPoolEmpId(value) {
      const parsed = this.parseJobJsonField(value)
      if (Array.isArray(parsed)) {
        for (let i = 0; i < parsed.length; i++) {
          const id = this.extractPoolEmpId(parsed[i])
          if (id) return id
        }
        return ''
      }
      if (parsed && typeof parsed === 'object') {
        const id = parsed.emp_id || parsed.empId || parsed.id
        return this.looksLikeEmpId(id) ? String(id) : this.sanitizePoolText(id)
      }
      const text = this.sanitizePoolText(parsed)
      return this.looksLikeEmpId(text) ? text : ''
    },
    extractAssignmentRecruiterEmpId(value) {
      if (value == null || value === '') return ''
      const parsed = this.parseJobJsonField(value)
      if (Array.isArray(parsed)) return ''
      if (parsed && typeof parsed === 'object') {
        const id = parsed.emp_id || parsed.empId || parsed.id
        return this.looksLikeEmpId(id) ? String(id) : ''
      }
      const text = this.sanitizePoolText(parsed)
      return this.looksLikeEmpId(text) ? text : ''
    },
    normalizePoolIdentity(value) {
      return this.sanitizePoolText(value).toLowerCase().replace(/\s+/g, ' ')
    },
    extractPoolEmails(value) {
      const parsed = this.parseJobJsonField(value)
      const emails = []
      const pushEmail = raw => {
        const text = this.normalizePoolIdentity(raw)
        if (text && text.includes('@')) emails.push(text)
      }
      if (Array.isArray(parsed)) {
        parsed.forEach(item => {
          this.extractPoolEmails(item).forEach(email => emails.push(email))
        })
        return emails
      }
      if (parsed && typeof parsed === 'object') {
        pushEmail(parsed.email || parsed.mail || parsed.user_email || parsed.userEmail)
        return emails
      }
      pushEmail(parsed)
      return emails
    },
    readSessionUserBags() {
      let userData = {}
      try {
        userData = JSON.parse(localStorage.getItem('userData') || '{}') || {}
      } catch (e) {
        userData = {}
      }
      const authUser = this.$store && this.$store.state && this.$store.state.auth
        ? this.$store.state.auth.user
        : null
      return [userData, authUser].filter(bag => bag && typeof bag === 'object')
    },
    currentPoolUserIdentity() {
      const empIds = []
      const emails = []
      const names = []
      const pushId = raw => {
        const id = this.normalizePoolIdentity(raw)
        if (id) empIds.push(id)
      }
      const pushEmail = raw => {
        const email = this.normalizePoolIdentity(raw)
        if (email && email.includes('@')) emails.push(email)
      }
      const pushName = raw => {
        const name = this.normalizePoolIdentity(raw)
        if (name && !this.looksLikeEmpId(name) && !this.isPoolRoleLabel(name)) names.push(name)
      }
      this.readSessionUserBags().forEach(bag => {
        pushId(bag.emp_id || bag.empId)
        pushEmail(bag.email || bag.mail || bag.user_email || bag.userEmail)
        pushName(bag.title || bag.name || bag.full_name || bag.fullName)
        pushName([bag.first_name, bag.last_name].filter(Boolean).join(' '))
      })
      pushId(this.empId)
      pushName(this.verifierName)
      return {
        empIds: [...new Set(empIds)],
        emails: [...new Set(emails)],
        names: [...new Set(names)],
      }
    },
    fieldMatchesCurrentUser(value, identity) {
      if (value == null || value === '') return false
      const empId = this.normalizePoolIdentity(this.extractPoolEmpId(value))
      if (empId && identity.empIds.includes(empId)) return true
      if (this.extractPoolEmails(value).some(email => identity.emails.includes(email))) return true
      const name = this.normalizePoolIdentity(this.displayPoolPersonName(value))
      return !!(name && identity.names.includes(name))
    },
    isCandidateAddedByCurrentUser(row) {
      if (!row) return false
      const identity = this.currentPoolUserIdentity()
      if (!identity.empIds.length && !identity.emails.length && !identity.names.length) return false
      const values = this.collectPoolNameSources(row, [
        'addedBy', 'added_by', 'created_by', 'createdBy', 'sourcer',
        'sourcer_name', 'sourcerName',
      ])
      if (row.sourcer_name) values.push(row.sourcer_name)
      return values.some(value => this.fieldMatchesCurrentUser(value, identity))
    },
    matchJobPersonName(value, people) {
      if (!Array.isArray(people) || !people.length) return ''
      const empId = this.extractPoolEmpId(value)
      if (empId) {
        const match = people.find(person => String(person.emp_id || person.empId || person.id) === String(empId))
        if (match) return this.sanitizePoolText(match.title || match.name)
      }
      const title = this.displayPoolPersonName(value)
      if (title) {
        const match = people.find(person => this.sanitizePoolText(person.title || person.name) === title)
        if (match) return this.sanitizePoolText(match.title || match.name)
      }
      return ''
    },
    isPoolManagerKey(key) {
      const k = String(key || '').toLowerCase().replace(/[\s_-]/g, '')
      return k === 'mgrid' || k === 'managerid' || k === 'manager' || k === 'managername'
        || k === 'pmgrid' || k === 'accountmgr' || k === 'accountmgrid'
    },
    collectPoolNameSources(row, keys) {
      const extra = this.parseJobJsonField(row && (row.extra_details || row.extraDetails))
      const assignment = this.findPoolAssignment(row)
      const bags = [row, extra, assignment, assignment && assignment.candidate_jobs]
      const values = []
      keys.forEach(key => {
        if (this.isPoolManagerKey(key)) return
        bags.forEach(bag => {
          if (bag && typeof bag === 'object' && !Array.isArray(bag) && bag[key] != null) {
            values.push(bag[key])
          }
        })
      })
      return values
    },
    resolvePoolPersonId(row, keys) {
      const values = this.collectPoolNameSources(row, keys)
      for (let i = 0; i < values.length; i++) {
        const id = this.extractPoolEmpId(values[i])
        if (id) return this.normalizePoolIdentity(id)
      }
      return ''
    },
    poolPersonDirectory() {
      const lists = []
      if (Array.isArray(this.allUsers)) lists.push(this.allUsers)
      else {
        try {
          const stored = JSON.parse(localStorage.getItem('allusers') || 'null')
          if (Array.isArray(stored)) lists.push(stored)
        } catch (e) { /* ignore */ }
      }
      if (this.jobData && Array.isArray(this.jobData.recruiters)) lists.push(this.jobData.recruiters)
      if (this.jobData && Array.isArray(this.jobData.sourcer)) lists.push(this.jobData.sourcer)
      return lists
    },
    lookupPoolUserName(empId) {
      const id = this.normalizePoolIdentity(empId)
      if (!id) return ''
      const lists = this.poolPersonDirectory()
      for (let i = 0; i < lists.length; i++) {
        const match = lists[i].find(person => {
          if (!person || typeof person !== 'object') return false
          const personId = this.normalizePoolIdentity(person.emp_id || person.empId || person.id)
          return personId && personId === id
        })
        if (match) {
          const name = this.sanitizePoolText(
            match.title || match.name || match.emp_name || match.employee_name
            || [match.first_name, match.last_name].filter(Boolean).join(' ')
          )
          if (name && !this.isPoolRoleLabel(name) && !this.looksLikeEmpId(name)) return name
        }
      }
      return ''
    },
    nameFromPoolValue(value, jobPeople) {
      const name = this.displayPoolPersonName(value)
      if (name) return name
      const fromJob = this.matchJobPersonName(value, jobPeople)
      if (fromJob) return fromJob
      const empId = this.extractPoolEmpId(value)
      return this.lookupPoolUserName(empId)
    },
    isSamePoolPerson(nameA, idA, nameB, idB) {
      const idLeft = this.normalizePoolIdentity(idA)
      const idRight = this.normalizePoolIdentity(idB)
      if (idLeft && idRight && idLeft === idRight) return true
      const nameLeft = this.normalizePoolIdentity(nameA)
      const nameRight = this.normalizePoolIdentity(nameB)
      return !!(nameLeft && nameRight && nameLeft === nameRight)
    },
    firstDistinctJobRecruiter(sourcerId, sourcerName) {
      const people = this.jobData && Array.isArray(this.jobData.recruiters) ? this.jobData.recruiters : []
      for (let i = 0; i < people.length; i++) {
        const person = people[i]
        const id = this.normalizePoolIdentity(person && (person.emp_id || person.empId || person.id))
        const name = this.sanitizePoolText(person && (person.title || person.name || [person.first_name, person.last_name].filter(Boolean).join(' ')))
          || this.lookupPoolUserName(id)
        if (!name && !id) continue
        if (this.isSamePoolPerson(name, id, sourcerName, sourcerId)) continue
        return { name, id }
      }
      return { name: '', id: '' }
    },
    isScalarAssignmentColumn(value) {
      if (value == null || value === '') return false
      return !Array.isArray(value)
    },
    pickPoolAssignmentColumn(row, key) {
      const assignment = this.findPoolAssignment(row)
      if (assignment && typeof assignment === 'object' && !Array.isArray(assignment)) {
        const value = assignment[key]
        return this.isScalarAssignmentColumn(value) ? value : ''
      }
      const value = row && row[key]
      return this.isScalarAssignmentColumn(value) ? value : ''
    },
    displayAssignmentColumnName(value, jobPeople) {
      if (!this.isScalarAssignmentColumn(value)) return ''
      const name = this.nameFromPoolValue(value, jobPeople)
      if (name) return name
      const text = this.sanitizePoolText(typeof value === 'object' ? '' : value)
      if (text && !this.looksLikeEmpId(text) && !this.isPoolRoleLabel(text)) return text
      return ''
    },
    resolvePoolSourcerId(row) {
      return this.extractPoolEmpId(this.pickPoolAssignmentColumn(row, 'sourcer'))
    },
    assignmentRecruiterIdKeys() {
      return [
        'recruiter', 'rec_id', 'recruiter_id', 'recruiterId',
        'assigned_recruiter', 'rec_emp_id',
      ]
    },
    assignmentRecruiterNameKeys() {
      return ['recruiter_name', 'recruiterName', 'recruiter', 'assigned_recruiter', 'rec_name']
    },
    poolAssignmentBags(row) {
      const assignment = this.findPoolAssignment(row)
      if (!assignment || typeof assignment !== 'object') return []
      return [assignment, assignment.candidate_jobs].filter(bag => bag && typeof bag === 'object' && !Array.isArray(bag))
    },
    pickPoolEmpIdFromBags(bags, keys) {
      for (let b = 0; b < bags.length; b++) {
        const bag = bags[b]
        if (!bag || typeof bag !== 'object' || Array.isArray(bag)) continue
        for (let k = 0; k < keys.length; k++) {
          if (this.isPoolManagerKey(keys[k])) continue
          const id = this.extractPoolEmpId(bag[keys[k]])
          if (id) return this.normalizePoolIdentity(id)
        }
      }
      return ''
    },
    collectPoolValuesFromBags(bags, keys) {
      const values = []
      bags.forEach(bag => {
        if (!bag || typeof bag !== 'object' || Array.isArray(bag)) return
        keys.forEach(key => {
          if (this.isPoolManagerKey(key)) return
          if (bag[key] != null && bag[key] !== '') values.push(bag[key])
        })
      })
      return values
    },
    resolveAssignmentRecruiterId(row) {
      const assignmentBags = this.poolAssignmentBags(row)
      const bags = assignmentBags.length ? assignmentBags : [row]
      const keys = this.assignmentRecruiterIdKeys()
      for (let b = 0; b < bags.length; b++) {
        const bag = bags[b]
        if (!bag || typeof bag !== 'object' || Array.isArray(bag)) continue
        for (let k = 0; k < keys.length; k++) {
          if (this.isPoolManagerKey(keys[k])) continue
          const id = this.extractAssignmentRecruiterEmpId(bag[keys[k]])
          if (id) return this.normalizePoolIdentity(id)
        }
      }
      return ''
    },
    lookupPoolUserNameFromRow(row, empId) {
      const id = this.normalizePoolIdentity(empId)
      if (!id) return ''
      const fromDir = this.lookupPoolUserName(id)
      if (fromDir) return fromDir
      const linkedValues = this.collectPoolNameSources(row, [
        'addedBy', 'added_by', 'created_by', 'createdBy', 'updatedBy', 'updated_by',
        'sourcer', 'sourcer_name', 'sourcerName',
      ])
      for (let i = 0; i < linkedValues.length; i++) {
        const valueId = this.normalizePoolIdentity(this.extractPoolEmpId(linkedValues[i]))
        if (valueId !== id) continue
        const name = this.nameFromPoolValue(linkedValues[i], this.jobData && this.jobData.sourcer)
        if (name) return name
      }
      const sourcerId = this.resolvePoolSourcerId(row)
      const addedById = this.resolvePoolPersonId(row, [
        'addedBy', 'added_by', 'created_by', 'createdBy', 'updatedBy', 'updated_by',
      ])
      if ((sourcerId && sourcerId === id) || (addedById && addedById === id)) {
        const sourcerName = sourcerId === id ? this.resolvePoolSourcerNameFromRow(row) : ''
        if (sourcerName) return sourcerName
        const empNames = this.collectPoolNameSources(row, [
          'Employee Name', 'employee_name', 'employeeName', 'emp_name',
        ])
        for (let i = 0; i < empNames.length; i++) {
          const name = this.displayPoolPersonName(empNames[i])
          if (name) return name
        }
      }
      return ''
    },
    readAssignmentRecruiterDisplayName(row, recId) {
      const assignmentBags = this.poolAssignmentBags(row)
      const bags = assignmentBags.length ? assignmentBags : [row]
      const values = this.collectPoolValuesFromBags(bags, this.assignmentRecruiterNameKeys())
      const sourcerId = this.resolvePoolSourcerId(row)
      const sourcerName = this.resolvePoolSourcerNameFromRow(row)
      const jobRec = this.firstDistinctJobRecruiter(sourcerId, sourcerName)
      for (let i = 0; i < values.length; i++) {
        const name = this.nameFromPoolValue(values[i], this.jobData && this.jobData.recruiters)
        if (!name) continue
        if (
          recId
          && this.isSamePoolPerson(name, '', jobRec.name, jobRec.id)
          && !this.isSamePoolPerson('', recId, jobRec.name, jobRec.id)
        ) {
          continue
        }
        return name
      }
      return ''
    },
    resolvePoolRecruiterId(row) {
      return this.extractAssignmentRecruiterEmpId(this.pickPoolAssignmentColumn(row, 'recruiter'))
    },
    resolvePoolSourcerNameFromRow(row) {
      return this.displayAssignmentColumnName(
        this.pickPoolAssignmentColumn(row, 'sourcer'),
        this.jobData && this.jobData.sourcer
      )
    },
    resolvePoolSourcerName(row) {
      return this.resolvePoolSourcerNameFromRow(row)
    },
    resolvePoolRecruiterName(row) {
      return this.displayAssignmentColumnName(
        this.pickPoolAssignmentColumn(row, 'recruiter'),
        this.jobData && this.jobData.recruiters
      )
    },
    poolResolvedSourcerName(item) {
      return this.resolvePoolSourcerName(item)
    },
    poolResolvedRecruiterName(item) {
      return this.resolvePoolRecruiterName(item)
    },
    poolLinkSourcer(item) {
      const name = this.poolResolvedSourcerName(item)
      if (name) return name
      const raw = this.pickPoolAssignmentColumn(item, 'sourcer')
      return this.sanitizePoolText(typeof raw === 'object' ? '' : raw)
    },
    sourceTextFromPoolValue(raw) {
      if (raw == null || raw === '') return ''
      const parsed = this.parseJobJsonField(raw)
      if (Array.isArray(parsed)) {
        for (let i = 0; i < parsed.length; i++) {
          const text = this.sourceTextFromPoolValue(parsed[i])
          if (text) return text
        }
        return ''
      }
      if (parsed && typeof parsed === 'object') {
        const nested = parsed.title || parsed.name || parsed.label || parsed.value || parsed.channel || parsed.source
        if (nested && nested !== parsed) return this.sourceTextFromPoolValue(nested)
        return ''
      }
      const text = this.sanitizePoolText(parsed)
      if (!text || this.isPoolRoleLabel(text) || this.isIntakePoolStatus(text) || this.isJobLifecycleStatus(text)) return ''
      return text
    },
    poolResolvedSourceChannel(item) {
      return this.sourceTextFromPoolValue(item && item.source) || this.resolvePoolSourceChannel(item)
    },
    resolvePoolSourceChannel(row) {
      const extra = this.parseJobJsonField(row && (row.extra_details || row.extraDetails))
      const assignment = this.findPoolAssignment(row)
      const bags = [row, extra, assignment]
      const keys = ['source', 'sourced', 'candidate_source', 'candidateSource', 'sourced_from', 'sourcedFrom']
      for (let b = 0; b < bags.length; b++) {
        const bag = bags[b]
        if (!bag || typeof bag !== 'object' || Array.isArray(bag)) continue
        for (let k = 0; k < keys.length; k++) {
          const text = this.sourceTextFromPoolValue(bag[keys[k]])
          if (text) return text
        }
      }
      return ''
    },
    pickPoolAddedOn(row) {
      const assignment = this.findPoolAssignment(row)
      const extra = this.parseJobJsonField(row && (row.extra_details || row.extraDetails))
      const bags = [assignment, extra, row]
      const keys = ['added_on', 'addedOn', 'createdAt', 'created_at']
      for (let b = 0; b < bags.length; b++) {
        const bag = bags[b]
        if (!bag || typeof bag !== 'object' || Array.isArray(bag)) continue
        for (let k = 0; k < keys.length; k++) {
          const raw = bag[keys[k]]
          if (raw == null || raw === '') continue
          const t = new Date(raw).getTime()
          if (Number.isFinite(t) && t > 0) return raw
        }
      }
      return ''
    },
    poolAddedOnMs(row) {
      const raw = row && (row.added_on || row.addedOn || row.createdAt || row.created_at)
      const t = new Date(raw || 0).getTime()
      return Number.isFinite(t) ? t : 0
    },
    comparePoolCandidatesNewestFirst(a, b) {
      const tb = this.poolAddedOnMs(b)
      const ta = this.poolAddedOnMs(a)
      if (tb !== ta) return tb - ta
      const ib = Number(b && b.id) || 0
      const ia = Number(a && a.id) || 0
      return ib - ia
    },
    resetCandidatePoolPage() {
      this.currentPage = 1
      localStorage.setItem('currentPage', '1')
    },
    slimJobPoolCandidate(row) {
      if (!row || typeof row !== 'object') return row
      const first = row.first_name
      const last = row.last_name
      const currentStatus = this.resolveJobPoolCandidateStatus(row)
      const addedOn = this.pickPoolAddedOn(row)
      const assignment = this.findPoolAssignment(row)
      const assignmentSourcer = this.pickPoolAssignmentColumn(row, 'sourcer')
      const assignmentRecruiter = this.pickPoolAssignmentColumn(row, 'recruiter')
      const assignmentRecruiterId = this.extractAssignmentRecruiterEmpId(assignmentRecruiter)
      const employeeName = (assignment && (assignment['Employee Name'] || assignment.employee_name || assignment.employeeName))
        || row['Employee Name'] || row.employee_name || row.employeeName
      const addedBy = row.addedBy || row.added_by
        || (assignment && (assignment.addedBy || assignment.added_by))
      const updatedBy = row.updatedBy || row.updated_by
        || (assignment && (assignment.updatedBy || assignment.updated_by))
      return {
        id: row.id,
        candidate_id: row.candidate_id,
        full_name: row.full_name || [first, last].filter(Boolean).join(' '),
        first_name: first,
        last_name: last,
        added_on: addedOn,
        addedOn: addedOn,
        created_at: row.created_at || addedOn,
        createdAt: row.createdAt || row.created_at || addedOn,
        email: row.email,
        contact_no: row.contact_no,
        curr_location: row.curr_location,
        sourcer_name: this.resolvePoolSourcerName(row),
        rec_name: this.resolvePoolRecruiterName(row),
        sourcer_emp_id: this.resolvePoolSourcerId(row),
        rec_emp_id: this.resolvePoolRecruiterId(row),
        source: this.resolvePoolSourceChannel(row),
        recruiter: assignmentRecruiter || '',
        rec_id: assignmentRecruiterId || '',
        recruiter_id: assignmentRecruiterId || '',
        recruiter_name: assignmentRecruiter ? this.resolvePoolRecruiterName(row) : '',
        assigned_to: row.assigned_to || row.assignedTo,
        sourcer: assignmentSourcer || '',
        addedBy,
        added_by: row.added_by || row.addedBy || addedBy,
        updatedBy,
        updated_by: row.updated_by || row.updatedBy || updatedBy,
        created_by: row.created_by || row.createdBy,
        createdBy: row.createdBy || row.created_by,
        'Employee Name': employeeName,
        employee_name: employeeName,
        candidateStatus: currentStatus,
        status: currentStatus,
        reason: row.reason,
        comment: row.comment,
        extra_details: row.extra_details,
        cv_path: row.cv_path,
        curr_company: row.curr_company,
        curr_postion: row.curr_postion,
        exp: row.exp,
        ctc: row.ctc,
        notice_period: row.notice_period,
        gender: row.gender,
      }
    },
    parseJobJsonField(value) {
      if (typeof value !== 'string') return value
      const trimmed = value.trim()
      if (!trimmed.startsWith('[') && !trimmed.startsWith('{')) return value
      try {
        return JSON.parse(trimmed)
      } catch (e) {
        return value
      }
    },
    displayNameFromField(value) {
      const parsed = this.parseJobJsonField(value)
      if (Array.isArray(parsed) && parsed[0]) return parsed[0].title || parsed[0].name || value
      if (parsed && typeof parsed === 'object') return parsed.title || parsed.name || value
      return value
    },
    formatJobDate(value) {
      if (!value) return value
      const m = moment(value)
      return m.isValid() ? m.format('DD MMM YYYY') : value
    },
    applyJobHeader(job) {
      if (!job) return false
      const next = { ...job }
      if (typeof next.client === 'string') next.client = this.displayNameFromField(next.client)
      if (typeof next.domain === 'string') next.domain = this.displayNameFromField(next.domain)
      if (typeof next.account_mgr === 'string') next.account_mgr = this.displayNameFromField(next.account_mgr)
      if (typeof next.poc === 'string') next.poc = this.displayNameFromField(next.poc)
      if (next.created_by != null) next.created_by = this.displayNameFromField(next.created_by)
      if (next.createdAt) next.createdAt = this.formatJobDate(next.createdAt)
      if (next.target_date) next.target_date = this.formatJobDate(next.target_date)
      if (typeof next.recruiters === 'string') next.recruiters = this.parseJobJsonField(next.recruiters)
      if (typeof next.sourcer === 'string') next.sourcer = this.parseJobJsonField(next.sourcer)
      this.jobData = next
      this.jobLoadError = null
      this.jobHeaderLoading = false
      this.blueCollar = next.type === 'Contractual' && next.category === 'Blue Collar' && next.payroll === 'Sattva Payroll' && next.vertical === 'Infra Industry'
      this.recruiters = next.recruiters
      this.account_mgr = next.account_mgr
      this.sourcer = next.sourcer ? next.sourcer : ''
      return true
    },
    applyCandidateCounts(rows) {
      if (!this.jobData || !Array.isArray(rows)) return
      const statusOf = c => c.candidateStatus || c.status
      const count = pred => rows.filter(pred).length
      const hasCounts = this.jobData.initiated != null || this.jobData.profileshared != null || this.jobData.inprocess != null
      if (hasCounts) return
      this.jobData = {
        ...this.jobData,
        initiated: count(c => ['Initiated', 'UploadedBySourcer', 'UploadedByRecruiter', 'AssignedByMassMail'].includes(statusOf(c))),
        profileshared: count(c => statusOf(c) === 'ProfileShared'),
        inprocess: count(c => statusOf(c) === 'Inprocess'),
        shortlisted: count(c => statusOf(c) === 'Shortlisted'),
        offered: count(c => statusOf(c) === 'Offered'),
        joined: count(c => statusOf(c) === 'Joined'),
      }
    },
    applyCandidateList(list, todayProfiles) {
      const rows = Array.isArray(list) ? list.map(this.slimJobPoolCandidate) : []
      rows.sort((a, b) => this.comparePoolCandidatesNewestFirst(a, b))
      this.fetchCandidates = rows
      this.fetchCandidatesBKP = rows
      this.totalRows = rows.length
      if (Array.isArray(todayProfiles)) {
        this.todaysCandidates = todayProfiles.map(this.slimJobPoolCandidate)
      } else {
        const today = moment().format('YYYY-MM-DD')
        this.todaysCandidates = rows.filter(c => String(c.createdAt || '').startsWith(today))
      }
      if (this.resetPoolPageOnRefresh) {
        this.resetCandidatePoolPage()
        this.resetPoolPageOnRefresh = false
      }
      this.candidatesLoading = false
      this.canLoadingDone = true
      this.setOriginalsForAllCandidates()
      if (this.filterType === 'my') this.filterCandidate('my')
      this.applyCandidateCounts(rows)
    },
    loadJobNotesAndTimeline(id) {
      NoteService.getAllNotesJobWise(id).then(res => {
        if (res && (res.status === 'OK' || res.status === 200) && res.data !== undefined) this.notes = res.data
        else if (Array.isArray(res)) this.notes = res
        else if (res && Array.isArray(res.data)) this.notes = res.data
      }).catch(() => {})
      jobTimelineService.getJobTimeline(id).then(res => {
        if (res && (res.status === 'OK' || res.status === 200) && res.data !== undefined) this.timeline = res.data
        else if (Array.isArray(res)) this.timeline = res
        else if (res && Array.isArray(res.data)) this.timeline = res.data
      }).catch(() => {})
    },
    loadJobViewFallback(id, opts) {
      const headerOnly = opts && opts.headerOnly
      const listOnly = opts && opts.listOnly
      return JobService.getJobViewData(id).then(res => {
        if (this.isSessionAuthFailure(res)) {
          this.forceLogout()
          return false
        }
        if (res && (res.status === 403 || res.status === 404)) {
          if (!this.jobData) {
            this.jobLoadError = this.classifyJobHttpError(res)
            this.jobHeaderLoading = false
          }
          this.candidatesLoading = false
          this.canLoadingDone = true
          return false
        }
        if (!res || res.status !== 'OK' || !res.data) {
          if (!this.jobData) {
            this.jobLoadError = 'failed'
            this.jobHeaderLoading = false
          }
          this.candidatesLoading = false
          this.canLoadingDone = true
          return false
        }
        if (!headerOnly) {
          const job = this.extractJobRecord(res)
          if (job) this.applyJobHeader(job)
          else if (!this.jobData) {
            this.jobLoadError = 'not_found'
            this.jobHeaderLoading = false
          }
          if (res.data.timeline) this.timeline = res.data.timeline
          if (res.data.notes) this.notes = res.data.notes
        }
        if (!listOnly || !this.fetchCandidates.length) {
          this.applyCandidateList(res.data.candidates, res.data.todayProfiles)
        } else {
          this.candidatesLoading = false
          this.canLoadingDone = true
        }
        return true
      }).catch(() => {
        if (!this.jobData) {
          this.jobLoadError = 'failed'
          this.jobHeaderLoading = false
        }
        this.candidatesLoading = false
        this.canLoadingDone = true
        return false
      })
    },
    getJobData() {
      const id = this.id || (this.$route && this.$route.params && this.$route.params.id)
      this.id = id
      const keepExisting = !!(this.jobData && this.jobData.id && String(this.jobData.id) === String(id))
      if (id == null || id === '' || id === 'undefined' || id === 'null') {
        this.jobHeaderLoading = false
        this.candidatesLoading = false
        this.canLoadingDone = true
        this.jobLoadError = 'missing'
        if (!keepExisting) this.jobData = null
        return
      }

      this.jobHeaderLoading = !keepExisting
      this.candidatesLoading = true
      this.canLoadingDone = false
      if (!keepExisting) {
        this.jobLoadError = null
        if (this.jobData && String(this.jobData.id) !== String(id)) {
          this.jobData = null
          this.fetchCandidates = []
          this.fetchCandidatesBKP = []
        }
      }

      this.loadJobNotesAndTimeline(id)

      const jobReq = JobService.getJobData(id).then(res => {
        if (this.isSessionAuthFailure(res)) {
          this.forceLogout()
          return { kind: 'auth' }
        }
        if (res && (res.status === 403 || res.status === 404)) {
          return { kind: 'http', error: this.classifyJobHttpError(res) }
        }
        const job = this.extractJobRecord(res)
        if (job) {
          this.applyJobHeader(job)
          return { kind: 'ok' }
        }
        return { kind: 'empty' }
      }).catch(() => ({ kind: 'failed' }))

      const listReq = JobService.getCandidatesByJob(id).then(res => {
        if (this.isSessionAuthFailure(res)) {
          this.forceLogout()
          return { kind: 'auth' }
        }
        const list = this.extractCandidateList(res)
        if (list) {
          this.applyCandidateList(list)
          return { kind: 'ok' }
        }
        return { kind: 'empty' }
      }).catch(() => ({ kind: 'failed' }))

      Promise.all([jobReq, listReq]).then(([jobRes, listRes]) => {
        if (jobRes.kind === 'auth' || listRes.kind === 'auth') return
        if (jobRes.kind === 'http') {
          this.jobLoadError = jobRes.error
          this.jobHeaderLoading = false
          this.candidatesLoading = false
          this.canLoadingDone = true
          if (!keepExisting) this.jobData = null
          return
        }
        const needHeader = jobRes.kind !== 'ok' && !this.jobData
        const needList = listRes.kind !== 'ok'
        if (needHeader || needList) {
          this.loadJobViewFallback(id, { headerOnly: !needHeader && !!this.jobData, listOnly: !needList })
          return
        }
        this.jobHeaderLoading = false
        this.candidatesLoading = false
        this.canLoadingDone = true
      })
    },
    showModal(jobid, status) {
      this.job_id = jobid;
      this.statusSelected = status;
      //console.log(this.statusSelected);
      this.$refs["modal-update-status"].show();
    },
    /*showCModal(id) {
      this.candidate_id = id;
      //this.statusCSelected = status
      //console.log(this.statusCSelected);

      this.$refs["modal-cupdate-status"].show();
    },*/
    showModalNotes(jobid) {
      this.job_id = jobid;
      //console.log(this.job_id);
      this.$refs["modal-add-notes"].show();
    },
    showRemoveCandidateModal(id, jobid) {
      this.can_id = id
      this.job_id = jobid
      this.$refs["modal-remove-candidate"].show();
    },
    selectStatus(status) {
      this.statusSelected = status;
      for (var i = 0; i < this.statusOption.length; i++) {
        if (this.statusOption[i].text === status) {
          document.getElementById(this.statusOption[i].text).classList.remove('badge-light')
          document.getElementById(this.statusOption[i].text).classList.add('badge-primary')
          var el = document.getElementById(status);
          el.style.color = 'white';
        } else {
          document.getElementById(this.statusOption[i].text).classList.remove('badge-primary')
          document.getElementById(this.statusOption[i].text).classList.add('badge-light')
          var el = document.getElementById(this.statusOption[i].text);
          el.style.color = 'black';
        }
      }
    },
    /*selectCStatus(status) {
      this.statusCSelected = status;
      //console.log(this.statusCSelected);
      document.getElementById(status).classList.remove("badge-light");
      document.getElementById(status).classList.add("badge-primary");
      var el = document.getElementById(status);
      el.style.color = "white";
    },*/
    updateStatus() {
      const userData = JSON.parse(localStorage.getItem("userData"));

      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
      const username = `${userData.first_name} ${userData.last_name}`
      //console.log("user", user);
      const status = {
        status: this.statusSelected,
        updated_by: user,
        
      };
      JobService.updateJobStatus(this.job_id, status).then((res) => {
        //console.log(res.data);
        if (res.status === "OK") {
          const timelineData = {
            title: `${this.jobData.job_id} - Job Status Updated to ${this.statusSelected}`,
            description: `Previous Status : ${this.jobData.status}`,
            type: "info",
            createdBy: username,
            jobId: this.jobData.id,
            candidate_id: null
          }
          //console.log(timelineData);
          
          jobTimelineService.create(timelineData).then(res => {
            //console.log("timeline", res)
            
          })

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Job Status Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.getJobData();
        } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Job Status Update Failed",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
    },
    
    updateNotes() {
      const userData = JSON.parse(localStorage.getItem("userData"));

      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
      const username = `${userData.first_name} ${userData.last_name}`
      const notes = {
        note_description: this.note,
        jobId: this.job_id,
        recruiter_id: user,
      };
      //console.log(notes);
      NoteService.addNote(notes).then((res) => {
        //console.log(res.data);
        if (res.status === "OK") {
          const timelineData = {
            title: `${this.jobData.job_id} - Note Added`,
            description: `Note: ${res.data.note_description}`,
            type: "info",
            createdBy: username,
            jobId: this.jobData.id,
            candidate_id: null
          }
          //console.log(timelineData);
          
          jobTimelineService.create(timelineData).then(res => {
            //console.log("timeline", res)
          })
          
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Job Notes Added",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.getJobData();
        } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Job Note Add Failed",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
      //this.notes=''
    },
    removeCandidateFromJob() {
      if(this.removeCandidateReason) {
        const userData = JSON.parse(localStorage.getItem("userData"));

        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
        const username = `${userData.first_name} ${userData.last_name}`

        candidateService.removeCandidateFromJob(this.can_id, this.job_id).then(res => {
          if(res.status === "OK") {
            const timelineData = {
              title: `${this.jobData.job_id} - Candidate Removed from Job(${this.can_id})`,
              description: `Reason: ${this.removeCandidateReason}`,
              type: "danger",
              createdBy: username,
              jobId: this.jobData.id,
              candidate_id: this.can_id
            }
            this.addRemoveCandidateToTimeline(timelineData);
          } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
          }
        })
      }
      else {
        this.removeCandError = 'Reason Cannot be Empty'
      }
    },
    addRemoveCandidateToTimeline(data) {
      jobTimelineService.create(data).then(res => {
            //console.log("timeline", res)
      })
      this.getJobData();
      this.$toast({
            component: ToastificationContent,
            props: {
              title: "Candidate Removed from this Job",
              icon: "Trashicon",
              variant: "success",
            },
          });
    },
    resolveCandidateStatusVariant(status) {
      ////console.log("called")
      //const resolveCandidateStatusVariant = status => {
        
      if (status === 'Uploaded') return 'badge-secondary'
      if (status === 'Initiated') return 'badge-warning'
      if (status === 'ReviewReject') return 'badge-danger'
      if (status === 'ProfileShared') return 'badge-info'
      if (status === 'ScreenReject') return 'badge-danger'
      if (status === 'ScreenSelect') return 'badge-info'
      if (status === 'Duplicate') return 'badge-danger'
      if (status === 'Inprocess') return 'badge-info'
      if (status === 'On-Hold') return 'badge-warning'
      if (status === 'Shortlisted') return 'badge-success'
      if (status === 'Offered') return 'badge-success'
      if (status === 'NotOffered') return 'badge-danger'
      if (status === 'Joined') return 'badge-success'
      if (status === 'OfferDrop') return 'badge-danger'
      if (status === 'Rejected') return 'badge-danger'
      if (status === 'Wrong Number') return 'badge-danger'
      if (status === 'Not Answered') return 'badge-warning'
      if (status === 'Not Reachable') return 'badge-warning'
      if (status === 'Call Back') return 'badge-warning'
      if (status === 'Not Interested') return 'badge-danger'
      if (status === 'Not Relevant') return 'badge-danger'
      if (status === 'Early Attrition') return 'badge-danger'
      if (status === 'UploadedBySourcer') return 'badge-warning'
      if (status === 'UploadedByRecruiter') return 'badge-warning'
      if (status === 'AssignedByMassMail') return 'badge-warning'
      if (status === 'AssignedByATSSourcer') return 'badge-warning'
      if (status === 'Confirmed') return 'badge-success'
      if (status === 'Document Submitted') return 'badge-success'
      if (status === 'Document Pending') return 'badge-warning'
      if (status === 'Drop') return 'badge-danger'
      if (status === 'Attrition') return 'badge-danger'

      //KPMG RPO Status
      if (status === 'Verified') return 'badge-info'
      if (status === 'Rejected') return 'badge-danger'
      if (status === 'Test Pending') return 'badge-warning'
      if (status === 'Test Reject') return 'badge-danger'
      if (status === 'Interview Pending') return 'badge-info'
      if (status === 'L1 Select') return 'badge-success'
      if (status === 'L1 Reject') return 'badge-danger'
      if (status === 'L2 Select') return 'badge-success'
      if (status === 'L2 Reject') return 'badge-danger'
      
      
      return 'badge-secondary'
      
  
    },
    updateParent(i) {
      //console.log(i)
      this.resetPoolPageOnRefresh = true
      this.resetCandidatePoolPage()
      this.getJobData()
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    // updateClick(candidate,jobid, status) {
    //    this.updateClicked = !this.updateClicked
    //    ////console.log('text1', text, text1)
    //    //console.log('CANDIDATE STATUS', candidate)
    //    this.prevStatus = status
    //    this.candidateId = candidate.id
    //    this.jobId = jobid
    //    this.candidate = candidate
    //    if(this.updateClicked) {
    //     this.computeStatusOption()
    //     this.$refs["modal-cupdate-status"].show();
    //    }  
    //     // document.getElementById('updatecan_' + id).style.display = "";
    //     // document.getElementById('badgeshow_' + id).style.display = "none";
    //     //document.getElementById('edit_' + id).style.display = "none";
    //   //  } else {
    //   //   this.$refs["modal-cupdate-status"].hide();
    //   //   // document.getElementById('updatecan_' + id).style.display = "none";
    //   //   // document.getElementById('badgeshow_' + id).style.display = "";
    //   //   //document.getElementById('edit_' + id).style.display = "block";
    //   //  }
       
       
    // },
    computeStatusOption() {
      this.cStatusOption = allowedNextStatusOptions(this.prevStatus, {
        client: this.jobData && this.jobData.client,
        positionType: this.jobData && (this.jobData.position_type || this.jobData.positionType),
        category: this.jobData && this.jobData.category,
        payroll: this.jobData && this.jobData.payroll,
        vertical: this.jobData && this.jobData.vertical,
        blueCollar: this.blueCollar,
      })
    },
    selectCStatus(status) {
      this.statusCSelected = status;

      //this.clicked = true
      ////console.log(this.statusCSelected);
      
      for (var i = 0; i < this.cStatusOption.length; i++) {
        if (this.cStatusOption[i].text === status) {
          document.getElementById(this.cStatusOption[i].text).classList.remove('badge-light')
          document.getElementById(this.cStatusOption[i].text).classList.add('badge-primary')
          var el = document.getElementById(status);
          el.style.color = 'white';
        } else {
          document.getElementById(this.cStatusOption[i].text).classList.remove('badge-primary')
          document.getElementById(this.cStatusOption[i].text).classList.add('badge-light')
          var el = document.getElementById(this.cStatusOption[i].text);
          el.style.color = 'black';
        }
      }
    },
  onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.currentPage = 1
        this.totalRows = filteredItems.length
        // if(this.pageNumber !== 1) {
           this.currentPage = 1
        // } else{
          //this.currentPage = 1
        //}
        
  },
  filterCandidate(type) {
    this.filterType = type
    localStorage.setItem('filterType', this.filterType)
    const source = Array.isArray(this.fetchCandidatesBKP) ? this.fetchCandidatesBKP : []
    const rows = type === 'my'
      ? source.filter(item => this.isCandidateAddedByCurrentUser(item))
      : source.slice()
    rows.sort((a, b) => this.comparePoolCandidatesNewestFirst(a, b))
    this.fetchCandidates = rows
    this.totalRows = rows.length
    this.resetCandidatePoolPage()
  },
  shareJD(jd_file) {

  },
  checkCandidateExistGetData() {
    this.loading = true
    const data = {
      firstName: this.canExist.firstName,
      lastName: this.canExist.lastName,
      skill: this.canExist.skill,
      company: this.canExist.company
    }
    elasticSearchService.checkCandidateExist(data).then(res => {
      if(res.status=== 'OK') {
        this.loading = false
        this.canExistCandidatesList = res.data.hits.map(item => item._source);
      }
    })
  },
  onRowSelected(items) {
    this.previewCV(items[0].cv_path,true)
      const rowsSelected = items.map(({id}) => ({id}))
      this.selectedCandidates = []
      for(var i in rowsSelected)
        this.selectedCandidates.push(rowsSelected[i].id);
        this.selectedCandidates = [...new Set(this.selectedCandidates)];
  },
  previewCV(cvFile,modal) {
        const key = cvFile.replace("/","%2F")
        const temp = key.split(".");
        const extension = temp[temp.length - 1]; // Or parts.pop();

        if(extension === 'pdf') {
            this.pdf = true
          } else if (extension === 'docx'){
            this.docx = true
          }  else if (extension === 'rtf'){
            this.rtf = true
          } else if (extension === 'doc'){
            this.doc = true
          } else if (extension !== 'docx' || extension !== 'pdf' || extension !== 'rtf') {
            this.otherDoc = true
          } 
          
          JobService.getFile(key)
            .then(res => {
              //console.log(res)
              this.dlink = res.file;
              var encodedUrl = encodeURIComponent(res.file);
              this.glink = //'https://ats.sattvahuman.in/download/' + response.data.cv_path
                "https://docs.google.com/viewer?url=" + encodedUrl + "&embedded=true";

              this.mlink = "https://view.officeapps.live.com/op/view.aspx?src=" + encodedUrl
              ////console.log(this.dlink)
              this.dlink = res.file;

          });
          if(this.pdf) {
            JobService.getFileBase64(key)
              .then(res => {
                ////console.log(res)
                const base64 = res.file;
                //var encodedUrl = encodeURIComponent(res.file);
                this.blink = "data:application/pdf;base64," + base64
                
            }); 
            
          }
          if(modal) {
          this.$refs["cv-preview-modal"].show();
          }
  },
  numDaysBetween(d1, d2) {
        var diff = Math.abs(d1.getTime() - d2.getTime());
        return diff / (1000 * 60 * 60 * 24);
    },
  assignJob() {
        if(this.selectedCandidates && this.selectedCandidates.length > 0) {
            const jid = this.jobData.id
            const userData = JSON.parse(localStorage.getItem("userData"));
            const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
            let canSource = 'ATS-CS'
            
            let sourcer = userData.emp_id
            let status = ''
            //let c = []
            const username = `${userData.first_name} ${userData.last_name}`
            // const userRole = JSON.parse(localStorage.getItem('userData')).roles[0]

            this.selectedCandidates.forEach(id => {
                //c.push[id]
                const createdAt = this.canExistCandidatesList.filter(item => item.id === id)[0].createdAt
                const now = new Date();
                const diff = this.numDaysBetween(now, new Date(createdAt))
                const source = this.canExistCandidatesList.filter(item => item.id === id)[0].source
                
                // if(diff > 5 ) {
                //     canSource = 'ATS'
                //     console.log('source diff greater',canSource, diff, createdAt)
                // } else {
                //     canSource = source
                //     console.log('source diff less',canSource, diff, createdAt)
                // }
                if(diff > 30 ) {
                    sourcer = 'ATS'
                } else {
                    sourcer = sourcer
                }

                let data = {
                    job_id: jid,
                    candidate_id: [id],
                    candidateStatus: 'AssignedByATSSourcer',
                    source: canSource,
                    addedBy: user,
                    updatedBy: user,
                    sourcer: sourcer,
                    //recruiter: userData.emp_id
                }
                const jt =  {
                        title: `Candidate Id - ${id} - Assigned to the job with Status ${data.candidateStatus}`,
                        description: `CS-Assign via Candidate Search Before Naukri View`, /// CS-Changed means candidate status changed
                        type: "success",
                        createdBy: username,
                        jobId: jid,
                        candidate_id: id,
                        candidateStatus: data.candidateStatus
                    }
                data.jt = jt
                
                JobService.assignCandidateToJob(data).then(res => {
                    
                    if(res.status === "OK") {
                      this.resetPoolPageOnRefresh = true
                      this.resetCandidatePoolPage()
                      this.getJobData()
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: 'Candidate Added to Job, Please Fill in rest details to share Profile',
                        icon: 'EditIcon',
                        variant: 'success',
                        timeout: 10000,
                        },
                    })
                    
                    } else if (res.status === 410 || res.message === 'Candidate already exist in Current Job') {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: 'Failed! Candidate already exist in Job !!!',
                        icon: 'EditIcon',
                        variant: 'danger',
                        timeout: 5000,
                        },
                    })
                    } else if ((res.status === 401 ) || (res.status === 403 )) {
            
                        window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                        
                        localStorage.clear();
                        this.$router.push({ name: "auth-login" });
                    } else {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: 'Candidate Add to Job Failed !!!',
                        icon: 'EditIcon',
                        variant: 'danger',
                        timeout: 5000,
                        },
                    })
                    }
                })
            })
        } else {
            alert('No Candidate Selected!!!')
        }
    }, 
    restorePagination() {
      const savedPage = localStorage.getItem('currentPage');
      
      
      // Or const savedPage = sessionStorage.getItem('currentPage');
      if (savedPage) {
        this.currentPage = parseInt(savedPage);
      }
    },
    restorePageSize() {
      
      const perPage = localStorage.getItem('pageSize');
      //console.log('saved page: ',savedPage, parseInt(savedPage))
      this.perPage = perPage
      // Or const savedPage = sessionStorage.getItem('currentPage');
      if (perPage) {
        this.perPage = perPage
      }
    },
    onPageChange(pageNumber) {
      this.currentPage = pageNumber;
      localStorage.setItem('currentPage', this.currentPage);
      
      // Or sessionStorage.setItem('currentPage', pageNumber);
    },
    onPerPageChange(pageSize) {
      this.perPage = pageSize
      localStorage.setItem('pageSize', this.perPage);
    },
    async downloadJobtracker(id) {
      JobService.getJobTracker(id).then(res => {
        if(res.status === 200) {
          this.jobTracker = res.data.data
          const workbook = new Excel.Workbook();
          const worksheet = workbook.addWorksheet('Job Tracker');

          const headers = [
            { header: 'Candidate ID', key: 'Candidate ID', width: 15 },
            { header: 'Candidate Name', key: 'Candidate Name', width: 25 },
            { header: 'Email ID', key: 'Email ID', width: 25 },
            { header: 'Contact number', key: 'Contact number', width: 18 },
            { header: 'Current Company', key: 'Current Company', width: 20 },
            { header: 'Current Designation', key: 'Current Designation', width: 20 },
            { header: 'Current Location', key: 'Current Location', width: 18 },
            { header: 'Preferred Location', key: 'Preferred Location', width: 20 },
            { header: 'Current CTC', key: 'Current CTC', width: 15 },
            { header: 'Expected CTC', key: 'Expected CTC', width: 15 },
            { header: 'Experience', key: 'Experience', width: 12 },
            { header: 'Notice Period', key: 'Notice Period', width: 15 },
            { header: 'Qualification', key: 'Qualification', width: 20 },
            { header: 'Relevant Experience', key: 'Relevant Experience', width: 18 },
            { header: 'Added on', key: 'Added on', width: 18 },
            { header: 'Status', key: 'Status', width: 12 },
            { header: 'Sourcer', key: 'Sourcer', width: 15 },
            { header: 'Recruiter', key: 'Recruiter', width: 15 },
            { header: 'Last Updated on', key: 'Last Updated on', width: 18 },
            { header: 'Position Name', key: 'Position Name', width: 20 },
            { header: 'Client', key: 'Client', width: 20 },
          ];

          worksheet.columns = headers;
          // Add rows to the worksheet from JSON data
          // Set styles and formats if necessary
          worksheet.columns.forEach(column => {
            column.eachCell((cell, number) => {
              cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
              };
            });
          });
          worksheet.eachRow((row, rowNumber) => {
            row.eachCell((cell, colNumber) => {
              if (rowNumber === 1) { // For header row
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFFFCC00' },
                  bgColor: { argb: 'FF0000FF' }
                };
              }
            });
          });
          this.jobTracker.forEach(item => {
            worksheet.addRow(item);
          });

          // Write to a buffer
          //const buffer = await 
          workbook.xlsx.writeBuffer().then(buffer => {
            // Use file-saver to save the file
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Job-Tracker-${this.jobData.job_id}.xlsx`);
          });
          
        }
      })

      
    },
    async downloadClientTracker(jobId) {
      try {
        this.isDownloading = true
        const today = new Date().toISOString().split('T')[0]
        const response = await JobService.getClientTracker(jobId, today, today)
        if (response.status === 200 && response.data.data.length > 0) {
          const workbook = new Excel.Workbook();
          const worksheet = workbook.addWorksheet('Client Tracker');

          // Get headers from first data object
          const firstRow = response.data.data[0];
          const headers = Object.keys(firstRow).map(key => ({
            header: key,
            key: key,
            width: key.length * 1.5 // Adjusted width calculation
          }));

          worksheet.columns = headers;

          // Apply number format to specific columns
          worksheet.columns.forEach(column => {
            if (['Total Experience (Year.Month)', 'Relevant Experience (Year.Month)', 'Current CTC', 'Expected CTC (Hike %)', 'Notice Period'].includes(column.header)) {
              column.numFmt = '0.00';
              column.eachCell({ includeEmpty: false }, (cell, rowNumber) => {
                if (rowNumber > 1) {
                  let value = cell.value;
                  if (typeof value === 'string') {
                    // Remove any non-numeric characters except decimal point and minus
                    const numericValue = value.replace(/[^\d.-]/g, '');
                    // Check if the cleaned value is a valid number
                    if (!isNaN(numericValue) && numericValue.length > 0) {
                      cell.value = Number(numericValue);
                      cell.numFmt = '0.00';
                    }
                  }
                }
              });
            }
          });

          // Add styling and borders
          worksheet.eachRow((row, rowNumber) => {
            row.eachCell((cell, colNumber) => {
              cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
              };
              if (rowNumber === 1) {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFFFCC00' }
                };
              }
            });
          });

          // Add data rows
          response.data.data.forEach(item => {
            worksheet.addRow(item);
          });

          const buffer = await workbook.xlsx.writeBuffer();
          saveAs(
            new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 
            `client_tracker_${today}.xlsx`
                                            
          );
        } else {
          throw new Error('No data available for download')
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message || 'Error downloading client tracker',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isDownloading = false
      }
    },

    showCustomDateModal() {
      this.$bvModal.show('modal-custom-date')
    },

    async handleCustomDateDownload(bvModalEvent) {
      bvModalEvent.preventDefault()

      try {
        if (!this.customDateRange.startDate || !this.customDateRange.endDate) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Please select both start and end dates',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          return
        }

        this.isCustomDownloading = true // Add this loading state

        const response = await JobService.getCustomDateClientTracker(
          this.jobData.id,
          this.customDateRange.startDate,
          this.customDateRange.endDate
        )
        if (response.status === 200) {
          const workbook = new Excel.Workbook();
          const worksheet = workbook.addWorksheet('Client Tracker');

          // Get headers from response data
          const firstRow = response.data.data[0];
          const headers = Object.keys(firstRow).map(key => ({
            header: key,
            key: key,
            width: key.length * 2 // Dynamic width based on header length
          }));

          worksheet.columns = headers;

          // Apply number format to specific columns
          worksheet.columns.forEach(column => {
            if (['Total Experience (Year.Month)', 'Relevant Experience (Year.Month)', 'Current CTC', 'Expected CTC (Hike %)', 'Notice Period'].includes(column.header)) {
              column.numFmt = '0.00'; // Set number format
              column.eachCell({ includeEmpty: false }, (cell, rowNumber) => {
                if (rowNumber > 1) { // Skip header row
                  // Convert string to number, handling special cases
                  let value = cell.value;
                  if (typeof value === 'string') {
                    // Remove any non-numeric characters except decimal point and minus
                    value = value.replace(/[^\d.-]/g, '');
                  }
                  cell.value = Number(value) || 0;
                }
              });
            }
          });

          // Add header styling
          worksheet.eachRow((row, rowNumber) => {
            row.eachCell((cell, colNumber) => {
              if (rowNumber === 1) {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFFFCC00' },
                  bgColor: { argb: 'FF0000FF' }
                };
              }
            });
          });

          // Add data rows
          response.data.data.forEach(item => {
            worksheet.addRow(item);
          });

          // Generate and download file
          const buffer = await workbook.xlsx.writeBuffer();
          saveAs(
            new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 
            `client_tracker_${this.customDateRange.startDate}_to_${this.customDateRange.endDate}.xlsx`
          );

          // Clear the date range and hide modal
          this.customDateRange.startDate = ''
          this.customDateRange.endDate = ''
          this.$bvModal.hide('modal-custom-date')
        } else {
          throw new Error('Failed to download tracker')
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message || 'Error downloading client tracker',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isCustomDownloading = false // Reset loading state
      }
    },
    getBusinessCandidates(business) {
      return this.fetchCandidates.filter(candidate => {
        const candidateBusiness = candidate.extra_details?.business;
        if (!candidateBusiness) return false;
        
        // For NON GS - US tab, return candidates that don't belong to GS - US or Spark
        if (business === 'NON GS - US') {
          const businesses = candidateBusiness.split(',').map(b => b.trim());
          return !businesses.includes('GS - US') && !businesses.includes('Spark');
        }
        
        // For other tabs, check if candidate's business matches the tab's business
        return candidateBusiness.split(',')
          .map(b => b.trim())
          .includes(business);
      });
    },

    getBusinessCandidatesCount(business) {
      return this.getBusinessCandidates(business).length;
    },

    parseExtraDetails(extraDetails) {
      try {
        if (typeof extraDetails === 'string') {
          return JSON.parse(extraDetails);
        }
        return extraDetails || {};
      } catch (error) {
        console.error('Error parsing extra details:', error);
        return {};
      }
    },

    formatKey(key) {
      // Convert snake_case or camelCase to Title Case with spaces
      return key
        .replace(/_/g, ' ')
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
    },
    async fetchKPMGDropDownOptions() {
    
      try {

        AdminConfigService.getClientDropdownList(this.jobData.client).then(response => {
        if (response.data && response.status === 200) {
          this.businessOptions = response.data.data.businessList.map(item => ({
            title: item.title,
          }))
          this.levelOptions = response.data.data.levelList.map(item => ({
            title: item.title,
          }))
          this.panelOptions = response.data.data.panelList.map(item => ({
            title: item.title,
          }))
          this.roundOptions = response.data.data.roundList.map(item => ({
            title: item.title,
          }))
        }
        })
         
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching KPMG options',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        console.error('Error fetching KPMG options:', error, this.jobData.client)
      }
    },
    showCandidateModal(candidate) {
      this.previewCV(candidate.cv_path, false)
      this.$bvModal.show('candidate-modal-' + candidate.id)
    },
    setOriginalBusinessLevel(candidate) {
      if (!candidate._original) candidate._original = {};
      candidate._original.business = candidate.extra_details?.business || '';
      candidate._original.level = candidate.extra_details?.level || '';
    },

    // Call this after fetching candidates to set originals for all
    setOriginalsForAllCandidates() {
      if (this.fetchCandidates && Array.isArray(this.fetchCandidates)) {
        this.fetchCandidates.forEach(this.setOriginalBusinessLevel);
      }
      if (this.todaysCandidates && Array.isArray(this.todaysCandidates)) {
        this.todaysCandidates.forEach(this.setOriginalBusinessLevel);
      }
    },
    
    updateVerification(status, candidate) {
      const statusText = status === 'verified' ? 'Verified' : 'Rejected'
      const now = new Date().toISOString()
      const transitionBy = this.verifierName

      // Ensure extra_details and transition array exist
      if (!candidate.extra_details) candidate.extra_details = {}
      if (!candidate.extra_details.transition) candidate.extra_details.transition = []

      // Get original values (from _original, set at load time)
      const originalBusiness = candidate._original?.business || ''
      const originalLevel = candidate._original?.level || ''
      const newBusiness = candidate.extra_details.business || ''
      const newLevel = candidate.extra_details.level || ''

      // Track changes
      let transitionObj = {}
      let changed = false

      if (originalBusiness !== newBusiness) {
        transitionObj.businessFrom = originalBusiness
        transitionObj.businessTo = newBusiness
        changed = true
      }
      if (originalLevel !== newLevel) {
        transitionObj.levelFrom = originalLevel
        transitionObj.levelTo = newLevel
        changed = true
      }
      if (changed) {
        transitionObj.transitionOn = now
        transitionObj.transitionBy = transitionBy
        candidate.extra_details.transition.push(transitionObj)

        // Update the originals for next time
        candidate._original.business = newBusiness
        candidate._original.level = newLevel
      }

      let payload = {
        candidateStatus: statusText,
        extra_details: {
          ...candidate.extra_details,
          verifier: this.verifierName,
          verifierScore: candidate.extra_details.verifierScore,
          // transition: candidate.extra_details.transition, // already included via spread
        },
        updatedBy: this.empId
      }

      const timelineData = {
        title: `Candidate - ${candidate.candidate_id} status changed to ${statusText}`,
        description: `CS-Changed`,
        type: "success",
        createdBy: this.verifierName,
        jobId: this.jobData.id,
        action: 'job-view',
        candidate_id: candidate.id,
        candidateStatus: statusText,
        action: 'KPMG',
      }

      payload.jt = timelineData

      candidateService.updateCandidateStatus(candidate.id, this.jobData.id, payload).then(
          (res) => {
            
            if (res.status === "OK") {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Candidate updated',
                  icon: 'AlertCircleIcon',
                  variant: 'success',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Candidate not updated',
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
      )
      // ... send payload to API ...
    },
    
    openScheduleInterviewModal(candidate) {
      // Set the candidate for whom the interview is being scheduled
      this.candidate_id = candidate.id
      this.interviewForm = {
        candidate, // store the whole candidate object if you need more fields
        date: null,
        level: null,
        panel: null,
        round: null,
      };

      // Optionally, set panelOptions and roundOptions here if you want to fetch dynamically
      if (this.panelOptions.length === 0) {
        this.panelOptions = [
          { title: 'Panel 1' },
          { title: 'Panel 2' },
          { title: 'Panel 3' }
        ];
      }
      if (this.roundOptions.length === 0) {
      this.roundOptions = [
        { title: 'Round 1' },
        { title: 'Round 2' },
        { title: 'Round 3' },
        ];
      }

      this.$refs['modal-schedule-interview'].show();
    },
    scheduleInterview() {
      
      // Validate required fields
      if (
        !this.interviewForm.date ||
        !this.interviewForm.level ||
        !this.interviewForm.panel ||
        !this.interviewForm.round
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please fill all fields before scheduling the interview.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        });
        // Prevent modal from closing
        return false;
      }
      const userData = JSON.parse(localStorage.getItem("userData"));
      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
      const username = `${userData.first_name} ${userData.last_name}`
      const mgr_id = userData.mgr_id

      // Prepare payload
      // const payload = {
      //   candidateId: this.interviewForm.candidate.id,
      //   jobId: this.jobData.id,
      //   date: this.interviewForm.date,
      //   level: this.interviewForm.level,
      //   panel: this.interviewForm.panel,
      //   round: this.interviewForm.round,
      // };

      const payload = {
        candidate_id: this.candidate_id,
        job_id: this.jobData.id,
        scheduled_by: userData.emp_id,
        date_time: this.interviewForm.date,
        status: 'Scheduled',
        mgr_id: mgr_id,
        comment: '',
        level_name: this.interviewForm.level,
        panel_name: this.interviewForm.panel,
        round_name: this.interviewForm.round,
        send_reminder: this.interviewReminderSelected,
        reminder_timings: this.interviewReminderTimingSelected.join(',')
      }
      interviewService.create(payload).then(res => {
        if (res.status === "OK") {
          //this.reportStatus = ''
          //this.downloadReport = 'data:application/xlsx;base64,' + res.file
          this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: "Interview Scheduled!!!",
                        icon: "EditIcon",
                        variant: "success",
                        },
                    });
          
        } else if ((res.status === 401 ) || (res.status === 403 )) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
          this.reportStatus = 'Session Expired... Redirecting to Login Page'
          localStorage.clear();
          this.$router.push({ name: "auth-login" });
        } else if ((res.status === 400 ) ) {
          this.reportStatus = 'Some Error Occurred, Please Try after sometime. If Same Issue occurs multiple times, Kindly contact IT admin.'
          this.loading = false
          this.compiledData = null
        }
        else if ((res.status === 500 ) ) {
          this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: "Interview Schedule Failed!!!",
                        icon: "EditIcon",
                        variant: "danger",
                        },
                    });
          this.reportStatus = 'ERROR: ' + res.data.message + 'Kindly contact IT admin.'
          this.loading = false
          this.compiledData = null
        }
      })
      

      // TODO: Replace this with your actual API call
      

      // Show success toast
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Interview scheduled successfully!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });

      // Optionally, close the modal
      this.$refs['modal-schedule-interview'].hide();
    },
    isVerifier(empId) {
      return this.verifierList.some(verifier => verifier.emp_id === empId);
    },
    openApprovalModal() {
      this.$bvModal.show('approval-modal')
    },
    resetApprovalForm() {
      this.approvalForm = {
        reviewConfirmed: false,
        comments: '',
        rejectionReason: ''
      }
      this.showRejectionError = false
    },
    approveJob() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
      
      const updateData = {
        status: 'Active',
        comments: this.approvalForm.comments,
        updated_by: user
      }
      
      JobService.updateJobStatus(this.jobData.job_id, updateData).then(res => {
        if (res.status === "OK") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Job Approved Successfully',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
          
          // Refresh job data
          this.getJobData()
          
          // Close modal
          this.$bvModal.hide('approval-modal')
          this.resetApprovalForm()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Approval Failed',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        }
      }).catch(error => {
        console.error('Error approving job:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Approval Failed',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      })
    },
    rejectJob() {
      this.$bvModal.hide('approval-modal')
      this.$bvModal.show('rejection-modal')
    },
    confirmRejectJob() {
      if (!this.approvalForm.rejectionReason || this.approvalForm.rejectionReason.trim() === '') {
        this.showRejectionError = true
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Rejection reason is required',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        return
      }
      
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
      
      const updateData = {
        status: 'Rejected',
        comments: this.approvalForm.rejectionReason,
        updated_by: user
      }
      
      JobService.updateJobStatus(this.jobData.job_id, updateData).then(res => {
        if (res.status === "OK") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Job Rejected Successfully',
              icon: 'XCircleIcon',
              variant: 'warning',
            },
          })
          
          // Refresh job data
          this.getJobData()
          
          // Close modal
          this.$bvModal.hide('rejection-modal')
          this.resetApprovalForm()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Rejection Failed',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        }
      }).catch(error => {
        console.error('Error rejecting job:', error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Rejection Failed',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      })
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     vm.prevRoute = from
  //   })
  // },
  beforeDestroy() {
    if (this._availabilityUnsub) {
      this._availabilityUnsub()
      this._availabilityUnsub = null
    }
    if (this.scrollRestoreTimer) {
      clearTimeout(this.scrollRestoreTimer)
      this.scrollRestoreTimer = null
    }
  },
  updated() {
      this.restorePagination();
      this.restorePageSize();
      this.filterType = localStorage.getItem('filterType');
      this.$nextTick(() => {
        const scrollPosition = localStorage.getItem('lastPosition')
        if (!scrollPosition || scrollPosition === '[object Object]') {
          return
        }

        try {
          const y = JSON.parse(scrollPosition).y
          if (!y) {
            return
          }

          if (this.scrollRestoreTimer) {
            clearTimeout(this.scrollRestoreTimer)
          }

          this.scrollRestoreTimer = setTimeout(() => {
            window.scrollTo(0, y)
            this.scrollRestoreTimer = null
          }, 500)
        } catch (e) {
          // Ignore invalid saved scroll position
        }
      })
    },
    
  
};
</script>

<style scoped>
.demo-inline-spacing > * {
  margin-top: 0.1rem !important;
}
.b-avatar {
  width: 2.5rem !important;
  height: 2.5rem !important;
  font-size: 1.05rem !important;
}
.pool-sr-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.pool-sr-people {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  max-width: 100%;
}
.pool-sr-row {
  display: flex;
  align-items: center;
}
.pool-source-wrap {
  display: flex;
  justify-content: center;
  margin-top: 0.2rem;
}
.pool-source-chip {
  display: inline-block;
  padding: 0;
  border: none;
  border-radius: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.3;
  color: #4b465c;
  letter-spacing: 0.01em;
  text-transform: capitalize;
  background: transparent;
  white-space: nowrap;
}
.pool-sr-row ::v-deep .b-avatar {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px;
  padding: 0;
  border-radius: 50%;
  font-size: 0.65rem !important;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1;
}
.card-header {
  padding: 0.5rem !important;
}
.text-muted {
  color: #9c9c9f !important;
}
.col {
  padding-right: 0.1rem;
  padding-left: 0.1rem;
}

.vs__dropdown-toggle {
    padding: 0 0 4px 0;
    background: none;
    transform-style: preserve-3d;
    border-radius: 5px;
    padding: 0rem 5rem;
    box-shadow: 0 2px 2px rgb(0 0 0 / 25%), 0px 0px 2px rgb(0 0 0 / 20%);
}

</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.table.b-table > tbody > .table-active, [dir] .table.b-table > tbody > .table-active > th, [dir] .table.b-table > tbody > .table-active > td {
    background-color: #6cd2c6;
}
/* Hoisted to body — must beat .customizer (1051) without covering the FABs when closed. */
.dropdown-menu.jobs-view-actions-dropdown {
  z-index: 1060;
}
</style>
<style lang="scss" scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
